var _defs, _g, _path, _g2, _g3, _g4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "326.7pt",
    height: "269.79pt",
    viewBox: "0 0 326.7 269.79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2188 0h-3.125v-0.48438l2.0156-2.5156c0-0.00781 0.046875-0.066406 0.14062-0.17188 0.10156-0.11328 0.19531-0.21094 0.28125-0.29688h-2.2031v-0.46875h2.8125v0.46875l-2.2031 2.7188-0.23438 0.28125h2.5156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6719 0h-0.59375l-0.45312-1.2031h-1.6406l-0.4375 1.2031h-0.54688l1.5-3.9375h0.5625zm-1.2031-1.6094c-0.32422-0.85156-0.50781-1.3359-0.54688-1.4531-0.042969-0.11328-0.089844-0.26953-0.14062-0.46875h-0.015625c-0.054687 0.27344-0.12109 0.51562-0.20312 0.73438l-0.4375 1.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9062 0h-0.65625c-0.38672-0.61328-0.63281-0.99219-0.73438-1.1406-0.09375-0.14453-0.19531-0.26562-0.29688-0.35938-0.10547-0.10156-0.20312-0.16406-0.29688-0.1875-0.085937-0.03125-0.20312-0.046875-0.35938-0.046875h-0.59375v1.7344h-0.53125v-3.9375h1.75c0.23828 0 0.4375 0.015625 0.59375 0.046875 0.16406 0.03125 0.30469 0.10156 0.42188 0.20312 0.125 0.09375 0.21875 0.21484 0.28125 0.35938 0.0625 0.14844 0.09375 0.30469 0.09375 0.46875 0 0.29297-0.09375 0.53125-0.28125 0.71875-0.1875 0.17969-0.46094 0.29297-0.8125 0.34375v0.015625c0.25781 0.11719 0.50391 0.35156 0.73438 0.70312zm-2.9375-2.2031h1.1094c0.22656 0 0.40625-0.019531 0.53125-0.0625 0.13281-0.039063 0.23828-0.11328 0.3125-0.21875 0.082031-0.11328 0.125-0.23828 0.125-0.375 0-0.17578-0.070313-0.32812-0.20312-0.45312-0.125-0.125-0.33984-0.1875-0.64062-0.1875h-1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5312 0h-0.51562v-1.8594h-2.0469v1.8594h-0.53125v-3.9375h0.53125v1.6094h2.0469v-1.6094h0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406-4c0.55078 0 1.0039 0.1875 1.3594 0.5625 0.35156 0.375 0.53125 0.86719 0.53125 1.4688 0 0.61719-0.17969 1.1094-0.53125 1.4844-0.35547 0.36719-0.80859 0.54688-1.3594 0.54688-0.5625 0-1.0156-0.19141-1.3594-0.57812-0.34375-0.38281-0.51562-0.85156-0.51562-1.4062 0-0.64453 0.17188-1.1484 0.51562-1.5156 0.35156-0.375 0.80469-0.5625 1.3594-0.5625zm0 3.625c0.39453 0 0.71875-0.14062 0.96875-0.42188s0.375-0.67188 0.375-1.1719c0-0.50781-0.13281-0.89844-0.39062-1.1719-0.25-0.28125-0.5625-0.42188-0.9375-0.42188-0.39844 0-0.72656 0.13672-0.98438 0.40625-0.25 0.27344-0.375 0.6875-0.375 1.25 0 0.46094 0.125 0.82812 0.375 1.1094s0.57031 0.42188 0.96875 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1562 0h-0.48438v-3.2969h-0.015625l-1.125 3.2969h-0.46875l-1.1406-3.3438h-0.015625v3.3438h-0.48438v-3.9375h0.78125l0.92188 2.7812c0.10156 0.3125 0.16406 0.51172 0.1875 0.59375h0.015625c0.039063-0.15625 0.10938-0.36719 0.20312-0.64062l0.9375-2.7344h0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.375 0h-2.9375v-3.9375h2.8438v0.46875h-2.3281v1.2031h2.1875v0.46875h-2.1875v1.3281h2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7656-2.7812c-0.023437-0.25-0.11719-0.4375-0.28125-0.5625-0.15625-0.125-0.38281-0.1875-0.67188-0.1875-0.27344 0-0.49609 0.054688-0.67188 0.15625-0.16797 0.09375-0.25 0.23438-0.25 0.42188 0 0.17969 0.0625 0.30859 0.1875 0.39062 0.13281 0.085938 0.39062 0.16406 0.76562 0.23438 0.32031 0.074219 0.58203 0.15234 0.78125 0.23438 0.20703 0.074219 0.38281 0.1875 0.53125 0.34375 0.15625 0.15625 0.23438 0.37109 0.23438 0.64062 0 0.33594-0.13672 0.61719-0.40625 0.84375-0.27344 0.21875-0.625 0.32812-1.0625 0.32812-0.55469 0-0.96875-0.11719-1.25-0.35938-0.27344-0.25-0.41406-0.57031-0.42188-0.96875l0.48438-0.046875c0.03125 0.32422 0.15625 0.55859 0.375 0.70312 0.21875 0.13672 0.48438 0.20312 0.79688 0.20312 0.28906 0 0.52344-0.054688 0.70312-0.17188 0.17578-0.125 0.26562-0.28906 0.26562-0.5 0-0.20703-0.09375-0.35938-0.28125-0.45312-0.1875-0.10156-0.50781-0.20312-0.95312-0.29688-0.4375-0.10156-0.75781-0.23828-0.95312-0.40625-0.1875-0.17578-0.28125-0.39844-0.28125-0.67188 0-0.32031 0.11719-0.58203 0.35938-0.78125 0.25-0.20703 0.58594-0.3125 1.0156-0.3125 0.4375 0 0.78516 0.10547 1.0469 0.3125 0.26953 0.19922 0.41406 0.48438 0.4375 0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.42188-3.9375h1.4844c0.23828 0 0.44141 0.011719 0.60938 0.03125 0.16406 0.023438 0.32031 0.085938 0.46875 0.1875 0.14453 0.09375 0.25391 0.22656 0.32812 0.39062 0.070312 0.16797 0.10938 0.34375 0.10938 0.53125 0 0.36719-0.12109 0.65625-0.35938 0.875-0.23047 0.21875-0.60156 0.32812-1.1094 0.32812h-1v1.5938h-0.53125zm0.53125 1.875h1c0.625 0 0.9375-0.23828 0.9375-0.71875 0-0.15625-0.042969-0.28906-0.125-0.40625-0.085937-0.125-0.18359-0.20312-0.29688-0.23438-0.11719-0.03125-0.28906-0.046875-0.51562-0.046875h-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5312 0h-0.53125l-2.0625-3.0938h-0.015625v3.0938h-0.48438v-3.9375h0.53125l2.0625 3.0938v-3.0938h0.5zm-0.59375-4.8594c0 0.19922-0.054688 0.35156-0.15625 0.45312-0.10547 0.10547-0.23047 0.15625-0.375 0.15625-0.085938 0-0.15234-0.007812-0.20312-0.03125-0.054687-0.019531-0.12109-0.050781-0.20312-0.09375-0.125-0.082031-0.22656-0.125-0.29688-0.125-0.14844 0-0.22656 0.085938-0.23438 0.25h-0.32812c0-0.19531 0.050781-0.34766 0.15625-0.45312 0.11328-0.10156 0.24219-0.15625 0.39062-0.15625 0.11328 0 0.23828 0.042969 0.375 0.125 0.13281 0.085937 0.24219 0.125 0.32812 0.125 0.125 0 0.19531-0.082031 0.21875-0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0469 0c0 0.22656-0.046875 0.39844-0.14062 0.51562-0.085938 0.125-0.1875 0.21094-0.3125 0.26562l-0.125-0.20312c0.19531-0.09375 0.29688-0.28906 0.29688-0.57812h-0.26562v-0.54688h0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0469 0h-0.5625v-0.54688h0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625-3.9375-1.5312 3.9375h-0.53125l-1.5312-3.9375h0.5625l1.0156 2.8594c0.082031 0.1875 0.15625 0.40234 0.21875 0.64062 0.050781-0.20703 0.11719-0.42188 0.20312-0.64062l1.0781-2.8594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375-3.9375h1.3594c0.23828 0 0.44141 0.015625 0.60938 0.046875 0.17578 0.023437 0.34375 0.078125 0.5 0.17188s0.28906 0.22656 0.40625 0.39062c0.125 0.15625 0.21875 0.34375 0.28125 0.5625 0.070312 0.21094 0.10938 0.46875 0.10938 0.78125 0 0.57422-0.14062 1.0469-0.42188 1.4219-0.27344 0.375-0.74609 0.5625-1.4219 0.5625h-1.4219zm0.53125 3.4688h0.84375c0.16406 0 0.31641-0.007812 0.45312-0.03125 0.13281-0.019531 0.26953-0.078125 0.40625-0.17188 0.14453-0.09375 0.25781-0.25 0.34375-0.46875 0.09375-0.21875 0.14062-0.50391 0.14062-0.85938 0-0.19531-0.023438-0.37891-0.0625-0.54688-0.03125-0.17578-0.09375-0.33203-0.1875-0.46875-0.09375-0.14453-0.20312-0.25-0.32812-0.3125-0.11719-0.0625-0.23047-0.097656-0.34375-0.10938-0.11719-0.019531-0.26562-0.03125-0.45312-0.03125h-0.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312 0h-0.53125v-3.9375h0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5312-1.6562c0 0.19922-0.011719 0.38672-0.03125 0.5625-0.023438 0.16797-0.085938 0.34375-0.1875 0.53125-0.09375 0.17969-0.25 0.32812-0.46875 0.45312-0.21094 0.11328-0.49609 0.17188-0.85938 0.17188-0.34375 0-0.625-0.054688-0.84375-0.15625-0.21875-0.10156-0.38281-0.23828-0.48438-0.40625-0.09375-0.17578-0.15625-0.35156-0.1875-0.53125-0.023438-0.1875-0.03125-0.39453-0.03125-0.625v-2.2812h0.51562v2.2656c0 0.24219 0.015625 0.44922 0.046875 0.625 0.039062 0.16797 0.13281 0.32031 0.28125 0.45312 0.14453 0.125 0.36719 0.1875 0.67188 0.1875 0.30078 0 0.53125-0.050781 0.6875-0.15625 0.15625-0.10156 0.25391-0.24219 0.29688-0.42188 0.050781-0.17578 0.078125-0.40625 0.078125-0.6875v-2.2656h0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2344-3.4688h-1.2969v3.4688h-0.53125v-3.4688h-1.2812v-0.46875h3.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-1.25c-0.11719 0.44922-0.3125 0.78125-0.59375 1-0.28125 0.21094-0.625 0.3125-1.0312 0.3125-0.64844 0-1.1172-0.19531-1.4062-0.59375-0.29297-0.40625-0.4375-0.89453-0.4375-1.4688 0-0.625 0.17188-1.1133 0.51562-1.4688 0.34375-0.35156 0.78906-0.53125 1.3438-0.53125 0.375 0 0.69531 0.10156 0.96875 0.29688 0.28125 0.1875 0.47266 0.46875 0.57812 0.84375l-0.5 0.125c-0.09375-0.26953-0.23047-0.47266-0.40625-0.60938-0.16797-0.14453-0.38672-0.21875-0.65625-0.21875-0.42969 0-0.75781 0.14062-0.98438 0.42188-0.21875 0.28125-0.32812 0.66406-0.32812 1.1406 0 0.55469 0.11328 0.96484 0.34375 1.2344 0.23828 0.26172 0.54688 0.39062 0.92188 0.39062 0.3125 0 0.5625-0.082031 0.75-0.25 0.19531-0.16406 0.33203-0.41406 0.40625-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406-4c0.55078 0 1.0039 0.1875 1.3594 0.5625 0.35156 0.375 0.53125 0.86719 0.53125 1.4688 0 0.61719-0.17969 1.1094-0.53125 1.4844-0.35547 0.36719-0.80859 0.54688-1.3594 0.54688-0.5625 0-1.0156-0.19141-1.3594-0.57812-0.34375-0.38281-0.51562-0.85156-0.51562-1.4062 0-0.64453 0.17188-1.1484 0.51562-1.5156 0.35156-0.375 0.80469-0.5625 1.3594-0.5625zm0 3.625c0.39453 0 0.71875-0.14062 0.96875-0.42188s0.375-0.67188 0.375-1.1719c0-0.50781-0.13281-0.89844-0.39062-1.1719-0.25-0.28125-0.5625-0.42188-0.9375-0.42188-0.39844 0-0.72656 0.13672-0.98438 0.40625-0.25 0.27344-0.375 0.6875-0.375 1.25 0 0.46094 0.125 0.82812 0.375 1.1094s0.57031 0.42188 0.96875 0.42188zm0.67188-4.5781-0.59375 0.75h-0.39062l0.35938-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5312 0h-0.53125l-2.0625-3.0938h-0.015625v3.0938h-0.48438v-3.9375h0.53125l2.0625 3.0938v-3.0938h0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6406 0h-0.65625l-0.78125-1.125c-0.19922-0.26953-0.32031-0.45312-0.35938-0.54688h-0.015625c0 0.03125-0.39062 0.58984-1.1719 1.6719h-0.625l1.5156-2.0469-1.3438-1.8906h0.625l0.82812 1.1719c0.082031 0.13672 0.14844 0.24609 0.20312 0.32812 0.0625-0.125 0.42578-0.625 1.0938-1.5h0.57812l-1.3906 1.8594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.875 0h-2.4688v-3.9375h0.53125v3.4688h1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9219-0.54688c-0.49219 0.40625-1.0312 0.60938-1.625 0.60938-0.60547 0-1.0938-0.17969-1.4688-0.54688-0.36719-0.36328-0.54688-0.85156-0.54688-1.4688 0-0.375 0.070312-0.71875 0.21875-1.0312 0.15625-0.32031 0.37891-0.57031 0.67188-0.75 0.30078-0.17578 0.66406-0.26562 1.0938-0.26562 0.4375 0 0.78906 0.10156 1.0625 0.29688 0.26953 0.1875 0.45312 0.47656 0.54688 0.85938l-0.46875 0.14062c-0.074219-0.28125-0.21094-0.49219-0.40625-0.64062-0.1875-0.14453-0.43359-0.21875-0.73438-0.21875-0.48047 0-0.83984 0.14844-1.0781 0.4375-0.24219 0.29297-0.35938 0.67188-0.35938 1.1406 0 0.35547 0.054687 0.64844 0.17188 0.875 0.11328 0.23047 0.28516 0.40625 0.51562 0.53125 0.22656 0.11719 0.47656 0.17188 0.75 0.17188 0.41406 0 0.80078-0.13281 1.1562-0.40625v-0.71875h-1.1562v-0.48438h1.6562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6406-2.0938c0.25 0.074219 0.4375 0.19922 0.5625 0.375 0.125 0.16797 0.1875 0.35938 0.1875 0.57812s-0.058594 0.42188-0.17188 0.60938c-0.11719 0.17969-0.27734 0.3125-0.48438 0.40625-0.19922 0.085938-0.46875 0.125-0.8125 0.125h-1.5156v-3.9375h1.4844c0.47656 0 0.8125 0.10547 1 0.3125 0.19531 0.21094 0.29688 0.4375 0.29688 0.6875 0 0.17969-0.046875 0.33984-0.14062 0.48438-0.085937 0.14844-0.21875 0.26562-0.40625 0.35938zm-1.7188-0.1875h0.85938c0.17578 0 0.32031-0.00781 0.4375-0.03125 0.125-0.019531 0.22656-0.070312 0.3125-0.15625 0.09375-0.082031 0.14062-0.21094 0.14062-0.39062 0-0.1875-0.046875-0.32031-0.14062-0.40625-0.085938-0.09375-0.19531-0.14844-0.32812-0.17188-0.125-0.019531-0.28906-0.03125-0.48438-0.03125h-0.79688zm0 1.8125h0.98438c0.35156 0 0.59766-0.054688 0.73438-0.17188 0.13281-0.125 0.20312-0.28906 0.20312-0.5 0-0.21875-0.074219-0.38281-0.21875-0.5-0.14844-0.125-0.40625-0.1875-0.78125-0.1875h-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3125-1.2656c0 0.49219-0.10156 0.83594-0.29688 1.0312-0.1875 0.19922-0.46094 0.29688-0.8125 0.29688-0.35547 0-0.62109-0.097656-0.79688-0.29688-0.17969-0.19531-0.26562-0.49219-0.26562-0.89062l0.46875-0.0625c0.007813 0.26172 0.0625 0.46094 0.15625 0.59375 0.10156 0.125 0.25 0.1875 0.4375 0.1875 0.17578 0 0.30469-0.039062 0.39062-0.125 0.09375-0.082031 0.14453-0.17578 0.15625-0.28125 0.019531-0.11328 0.03125-0.25391 0.03125-0.42188v-2.7031h0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0469-2.2969h-0.54688v-0.54688h0.54688zm0 2.2969h-0.54688v-0.54688h0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0625 0h-0.48438v-3.0781c-0.24219 0.23047-0.5625 0.42188-0.96875 0.57812v-0.46875c0.55078-0.25781 0.92969-0.58594 1.1406-0.98438h0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0781-2.125c0.25 0.042969 0.4375 0.15625 0.5625 0.34375s0.1875 0.39844 0.1875 0.625c0 0.35547-0.13281 0.64844-0.39062 0.875-0.26172 0.23047-0.57422 0.34375-0.9375 0.34375-0.35547 0-0.64844-0.097656-0.875-0.29688-0.21875-0.20703-0.35156-0.47656-0.39062-0.8125l0.48438-0.0625c0.050781 0.26172 0.14062 0.46094 0.26562 0.59375 0.13281 0.125 0.30469 0.1875 0.51562 0.1875 0.21875 0 0.40625-0.078125 0.5625-0.23438 0.15625-0.16406 0.23438-0.36328 0.23438-0.59375 0-0.21875-0.074219-0.39844-0.21875-0.54688-0.13672-0.14453-0.32031-0.21875-0.54688-0.21875-0.09375 0-0.21094 0.023437-0.34375 0.0625l0.0625-0.42188c0.125 0 0.22266-0.00391 0.29688-0.015625 0.082031-0.019531 0.17188-0.050781 0.26562-0.09375 0.09375-0.050781 0.16406-0.11719 0.21875-0.20312 0.0625-0.09375 0.09375-0.20703 0.09375-0.34375 0-0.19531-0.070312-0.34766-0.20312-0.45312-0.125-0.11328-0.27344-0.17188-0.4375-0.17188-0.19922 0-0.35938 0.0625-0.48438 0.1875-0.11719 0.125-0.1875 0.30469-0.21875 0.53125l-0.48438-0.09375c0.0625-0.34375 0.19531-0.59766 0.40625-0.76562 0.21875-0.16406 0.47266-0.25 0.76562-0.25 0.33203 0 0.60938 0.10156 0.82812 0.29688 0.21875 0.19922 0.32812 0.4375 0.32812 0.71875 0 0.375-0.18359 0.64062-0.54688 0.79688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7969-0.9375h-0.53125v0.9375h-0.48438v-0.9375h-1.7031v-0.45312l1.7969-2.5469h0.39062v2.5469h0.53125zm-1.0156-0.45312v-1.7656l-1.2188 1.7656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0781-2.125c0.5 0.15625 0.75 0.49219 0.75 1 0 0.34375-0.125 0.63281-0.375 0.85938-0.24219 0.21875-0.54688 0.32812-0.92188 0.32812-0.38672 0-0.69922-0.11328-0.9375-0.34375-0.24219-0.22656-0.35938-0.51562-0.35938-0.85938 0-0.25 0.066406-0.46875 0.20312-0.65625 0.13281-0.1875 0.31641-0.29688 0.54688-0.32812v-0.015625c-0.39844-0.125-0.59375-0.39062-0.59375-0.79688 0-0.28906 0.10156-0.53125 0.3125-0.71875 0.20703-0.19531 0.47656-0.29688 0.8125-0.29688 0.34375 0 0.61719 0.10156 0.82812 0.29688 0.20703 0.19922 0.3125 0.44531 0.3125 0.73438 0 0.38672-0.19531 0.64844-0.57812 0.78125zm-0.54688-0.20312c0.17578 0 0.32812-0.054687 0.45312-0.17188 0.125-0.11328 0.1875-0.25391 0.1875-0.42188 0-0.17578-0.0625-0.32812-0.1875-0.45312s-0.28125-0.1875-0.46875-0.1875c-0.17969 0-0.32812 0.0625-0.45312 0.1875-0.11719 0.11719-0.17188 0.25781-0.17188 0.42188 0 0.19922 0.054687 0.35547 0.17188 0.46875 0.125 0.10547 0.28125 0.15625 0.46875 0.15625zm0 2c0.22656 0 0.41406-0.070313 0.5625-0.21875 0.15625-0.14453 0.23438-0.33594 0.23438-0.57812 0-0.22656-0.078125-0.41406-0.23438-0.5625-0.15625-0.15625-0.35156-0.23438-0.57812-0.23438-0.23047 0-0.42188 0.078125-0.57812 0.23438-0.14844 0.14844-0.21875 0.32812-0.21875 0.54688 0 0.23047 0.070312 0.42188 0.21875 0.57812 0.15625 0.15625 0.35156 0.23438 0.59375 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.875-2.3594c0.23828-0.16406 0.48438-0.25 0.73438-0.25 0.33203 0 0.61719 0.11719 0.85938 0.34375 0.25 0.23047 0.375 0.53906 0.375 0.92188 0 0.39844-0.125 0.73047-0.375 1-0.25 0.27344-0.57422 0.40625-0.96875 0.40625-0.33594 0-0.62109-0.085938-0.85938-0.26562-0.24219-0.1875-0.375-0.46094-0.40625-0.82812l0.5-0.046875c0.039063 0.25 0.12891 0.4375 0.26562 0.5625 0.13281 0.125 0.30078 0.1875 0.5 0.1875 0.23828 0 0.4375-0.09375 0.59375-0.28125s0.23438-0.41406 0.23438-0.6875c0-0.26953-0.078125-0.48438-0.23438-0.64062-0.15625-0.16406-0.35938-0.25-0.60938-0.25-0.3125 0-0.55469 0.125-0.71875 0.375l-0.45312-0.046875 0.39062-2.0312h1.9531v0.46875h-1.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5312-3.9375-1.1406 4.0625h-0.39062l1.1406-4.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5312-3.9531c0.85156 0 1.2812 0.67188 1.2812 2.0156 0 0.67969-0.10938 1.1836-0.32812 1.5156-0.21875 0.32422-0.53906 0.48438-0.95312 0.48438-0.85547 0-1.2812-0.66406-1.2812-2 0-0.67578 0.10938-1.1797 0.32812-1.5156 0.21875-0.33203 0.53516-0.5 0.95312-0.5zm0 3.625c0.25781 0 0.45312-0.125 0.57812-0.375 0.13281-0.25 0.20312-0.66016 0.20312-1.2344 0-0.39453-0.03125-0.70703-0.09375-0.9375-0.054688-0.22656-0.14062-0.39844-0.26562-0.51562-0.11719-0.11328-0.26172-0.17188-0.4375-0.17188-0.25 0-0.44531 0.13281-0.57812 0.39062-0.13672 0.25-0.20312 0.66406-0.20312 1.2344 0 0.38672 0.03125 0.69531 0.09375 0.92188 0.0625 0.23047 0.14844 0.40234 0.26562 0.51562 0.11328 0.11719 0.25781 0.17188 0.4375 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562-1.1875h-1.4844v-0.48438h1.4844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3281-1.8594c-0.09375 0.15625-0.22656 0.28125-0.39062 0.375-0.16797 0.09375-0.34375 0.14062-0.53125 0.14062-0.32422 0-0.60156-0.11328-0.82812-0.34375-0.23047-0.23828-0.34375-0.55078-0.34375-0.9375 0-0.38281 0.11328-0.70312 0.34375-0.95312 0.22656-0.25 0.52344-0.375 0.89062-0.375 0.36328 0 0.67969 0.14062 0.95312 0.42188 0.26953 0.28125 0.40625 0.77734 0.40625 1.4844 0 0.71094-0.125 1.2422-0.375 1.5938-0.24219 0.34375-0.58984 0.51562-1.0469 0.51562-0.29297 0-0.53906-0.078125-0.73438-0.23438-0.19922-0.16406-0.32031-0.41016-0.35938-0.73438l0.45312-0.046875c0.070313 0.41797 0.28906 0.625 0.65625 0.625 0.30078 0 0.53125-0.13281 0.6875-0.40625 0.15625-0.26953 0.23438-0.64453 0.23438-1.125zm-0.8125 0.09375c0.23828 0 0.42578-0.082031 0.5625-0.25 0.13281-0.16406 0.20312-0.375 0.20312-0.625 0-0.25781-0.074219-0.47656-0.21875-0.65625-0.13672-0.17578-0.3125-0.26562-0.53125-0.26562-0.23047 0-0.42188 0.09375-0.57812 0.28125-0.14844 0.1875-0.21875 0.41406-0.21875 0.67188 0 0.25 0.070313 0.45312 0.21875 0.60938 0.15625 0.15625 0.34375 0.23438 0.5625 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8125-3.5156c-0.38672 0.42969-0.71875 0.95312-1 1.5781s-0.44922 1.2734-0.5 1.9375h-0.5c0.007812-0.53125 0.14062-1.1133 0.39062-1.75 0.25781-0.64453 0.58594-1.2031 0.98438-1.6719h-1.9219v-0.46875h2.5469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812 0h-2.6094c0-0.21875 0.078125-0.44141 0.23438-0.67188 0.15625-0.22656 0.44141-0.51562 0.85938-0.85938 0.25781-0.20703 0.48828-0.42578 0.6875-0.65625 0.20703-0.22656 0.3125-0.45703 0.3125-0.6875 0-0.19531-0.074219-0.35938-0.21875-0.48438-0.13672-0.13281-0.30859-0.20312-0.51562-0.20312-0.21875 0-0.40234 0.070312-0.54688 0.20312-0.14844 0.13672-0.21875 0.33594-0.21875 0.59375l-0.5-0.046875c0.03125-0.375 0.16016-0.65625 0.39062-0.84375 0.22656-0.19531 0.51953-0.29688 0.875-0.29688 0.39453 0 0.69531 0.10938 0.90625 0.32812 0.21875 0.21094 0.32812 0.46484 0.32812 0.76562 0 0.25-0.09375 0.50781-0.28125 0.76562-0.17969 0.26172-0.53906 0.60547-1.0781 1.0312-0.28125 0.23047-0.46875 0.42969-0.5625 0.59375h1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.4062 0.46875h-0.35938c-0.29297-0.38672-0.52734-0.80078-0.70312-1.25-0.16797-0.44531-0.25-0.89062-0.25-1.3281 0-0.5 0.085938-0.96094 0.26562-1.3906 0.1875-0.42578 0.41406-0.82031 0.6875-1.1875h0.35938c-0.32422 0.52344-0.54297 0.98047-0.65625 1.375-0.10547 0.39844-0.15625 0.79688-0.15625 1.2031 0 0.86719 0.26953 1.7266 0.8125 2.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.2812-0.26562-0.32812 0.3125c-0.59375-0.47656-0.98438-1.1172-1.1719-1.9219v2.2188h-0.42188v-2.1094c-0.13672 0.55469-0.55859 1.1406-1.2656 1.7656l-0.3125-0.32812c0.64453-0.53125 1.0625-1.1289 1.25-1.7969h-0.89062v-0.40625h1.2188v-0.78125h-0.53125c-0.09375 0.25-0.21875 0.48047-0.375 0.6875l-0.42188-0.1875c0.34375-0.375 0.53125-0.86328 0.5625-1.4688l0.40625 0.125c0 0.15625-0.023438 0.30469-0.0625 0.4375h0.42188v-0.875h0.42188v0.875h1v0.40625h-1v0.78125h1.2656v0.40625h-0.92188c0.19531 0.80469 0.58203 1.4219 1.1562 1.8594zm-2.9844-1.4531-0.375 0.23438c-0.074219-0.28125-0.1875-0.50391-0.34375-0.67188v2.5h-0.4375v-2.3125c-0.09375 0.25-0.3125 0.57422-0.65625 0.96875l-0.32812-0.26562c0.51953-0.5625 0.84766-1.1797 0.98438-1.8594h-0.75v-0.42188h0.75v-1.0469h0.4375v1.0469h0.59375v0.42188h-0.59375v0.53125l0.03125-0.03125c0.19531 0.11719 0.42578 0.41797 0.6875 0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531-4.6875c0.28906 0.375 0.51953 0.78906 0.6875 1.2344 0.17578 0.44922 0.26562 0.89844 0.26562 1.3438 0 0.5-0.09375 0.96484-0.28125 1.3906-0.17969 0.42969-0.40234 0.82031-0.67188 1.1875h-0.34375c0.3125-0.51953 0.51953-0.97656 0.625-1.375 0.11328-0.39453 0.17188-0.79688 0.17188-1.2031 0-0.86328-0.26562-1.7227-0.79688-2.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.6562-3.6562-0.375 0.17188c-0.074219-0.3125-0.16406-0.5625-0.26562-0.75l0.40625-0.15625c0.09375 0.19922 0.17188 0.44531 0.23438 0.73438zm-1.8594-0.15625-0.17188 0.5c-0.48047-0.28125-1.0391-0.45312-1.6719-0.51562l0.17188-0.51562c0.70703 0.14844 1.2656 0.32422 1.6719 0.53125zm1.25 0.375-0.375 0.15625c-0.074219-0.30078-0.16406-0.54688-0.26562-0.73438l0.40625-0.15625c0.09375 0.19922 0.17188 0.44531 0.23438 0.73438zm0.90625 0.6875c-0.51172 0.8125-1.0859 1.4531-1.7188 1.9219-0.63672 0.46094-1.3984 0.80859-2.2812 1.0469l-0.26562-0.51562c0.9375-0.21875 1.7109-0.55078 2.3281-1 0.625-0.45703 1.125-1.0508 1.5-1.7812zm-2.6719 0.3125-0.20312 0.53125c-0.41797-0.30078-0.96484-0.48828-1.6406-0.5625l0.17188-0.5c0.67578 0.125 1.2344 0.30469 1.6719 0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.3438-2.5781-0.70312 1.5625-0.42188-0.17188 0.45312-1.0312-0.92188 0.17188 0.48438 2.1875-0.45312 0.125-0.5-2.2031-1.0625 0.20312-0.09375-0.45312 1.0781-0.1875-0.17188-0.78125 0.45312-0.125 0.17188 0.79688 1.4219-0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5938-4.6094c0.16406 0 0.30469 0.0625 0.42188 0.1875 0.11328 0.11719 0.17188 0.25 0.17188 0.40625s-0.058594 0.29297-0.17188 0.40625c-0.11719 0.11719-0.25781 0.17188-0.42188 0.17188-0.15625 0-0.29297-0.054688-0.40625-0.17188-0.11719-0.11328-0.17188-0.25-0.17188-0.40625s0.054687-0.28906 0.17188-0.40625c0.11328-0.125 0.25-0.1875 0.40625-0.1875zm0 0.8125c0.070312 0 0.12891-0.019531 0.17188-0.0625 0.039063-0.039063 0.0625-0.09375 0.0625-0.15625 0-0.070313-0.023437-0.12891-0.0625-0.17188-0.042969-0.039062-0.10156-0.0625-0.17188-0.0625-0.0625 0-0.11719 0.023438-0.15625 0.0625-0.042969 0.042969-0.0625 0.10156-0.0625 0.17188 0 0.0625 0.019531 0.11719 0.0625 0.15625 0.039062 0.042969 0.09375 0.0625 0.15625 0.0625zm-2.3906-0.39062c-0.11719 0.82422-0.30859 1.6367-0.57812 2.4375-0.26172 0.80469-0.57031 1.4453-0.92188 1.9219l-0.4375-0.29688c0.38281-0.53906 0.70312-1.1875 0.95312-1.9375 0.25781-0.75 0.42188-1.5156 0.48438-2.2969zm2.6719 4.0781-0.53125 0.125c-0.054688-0.57031-0.21094-1.2383-0.46875-2-0.25-0.76953-0.55469-1.4766-0.90625-2.125l0.45312-0.21875c0.75781 1.5859 1.2422 2.9922 1.4531 4.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531-3.3438-0.29688 0.4375c-0.44922-0.375-0.96875-0.64062-1.5625-0.79688l0.29688-0.4375c0.63281 0.23047 1.1562 0.49609 1.5625 0.79688zm2.4688 0.5625c-0.625 0.92969-1.25 1.6016-1.875 2.0156-0.625 0.41797-1.3281 0.73438-2.1094 0.95312l-0.3125-0.5c0.97656-0.20703 1.7656-0.53906 2.3594-1 0.59375-0.46875 1.1094-1.0781 1.5469-1.8281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6406 1.1562h-0.35938c-0.29297-0.38672-0.52734-0.80469-0.70312-1.25-0.16797-0.44531-0.25-0.89062-0.25-1.3281 0-0.5 0.085937-0.96094 0.26562-1.3906 0.1875-0.42578 0.41406-0.82031 0.6875-1.1875h0.35938c-0.32422 0.52344-0.54297 0.98047-0.65625 1.375-0.10547 0.39844-0.15625 0.79688-0.15625 1.2031 0 0.86719 0.26953 1.7227 0.8125 2.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.54688-4c0.28906 0.375 0.51953 0.78906 0.6875 1.2344 0.17578 0.44922 0.26562 0.89844 0.26562 1.3438 0 0.5-0.09375 0.96484-0.28125 1.3906-0.17969 0.42578-0.40234 0.82031-0.67188 1.1875h-0.34375c0.3125-0.52344 0.51953-0.98047 0.625-1.375 0.11328-0.39453 0.17188-0.79688 0.17188-1.2031 0-0.86328-0.26562-1.7227-0.79688-2.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3-1.0781h-0.82812l-0.23438 1.1406h-0.40625l0.23438-1.1406h-0.84375l-0.23438 1.1406h-0.40625l0.23438-1.1406h-0.45312v-0.39062h0.53125l0.20312-0.98438h-0.73438v-0.39062h0.8125l0.23438-1.1562h0.40625l-0.23438 1.1562h0.84375l0.23438-1.1562h0.40625l-0.23438 1.1562h0.46875v0.39062h-0.54688l-0.20312 0.98438h0.75zm-0.95312-1.375h-0.84375l-0.20312 0.98438h0.84375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.375 0h-2.9375v-3.9375h2.8438v0.46875h-2.3281v1.2031h2.1875v0.46875h-2.1875v1.3281h2.4219zm-0.85938-4.9531-0.59375 0.75h-0.39062l0.35938-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.0938-0.046875-0.15625 0.35938c-0.30469-0.11719-0.57812-0.27734-0.82812-0.48438-0.30469 0.15625-0.625 0.23438-0.96875 0.23438-0.55469 0-1.0078-0.1875-1.3594-0.5625-0.34375-0.38281-0.51562-0.875-0.51562-1.4688s0.16406-1.0781 0.5-1.4531c0.34375-0.38281 0.80078-0.57812 1.375-0.57812 0.55078 0 1.0039 0.1875 1.3594 0.5625 0.35156 0.375 0.53125 0.86719 0.53125 1.4688 0 0.64844-0.19922 1.1641-0.59375 1.5469 0.21875 0.15625 0.4375 0.28125 0.65625 0.375zm-1.0625-0.65625c0.30078-0.28906 0.45312-0.71094 0.45312-1.2656 0-0.5-0.125-0.89062-0.375-1.1719s-0.57422-0.42188-0.96875-0.42188c-0.39844 0-0.71875 0.13672-0.96875 0.40625-0.25 0.27344-0.375 0.66797-0.375 1.1875 0 0.51172 0.125 0.90625 0.375 1.1875 0.25 0.27344 0.57031 0.40625 0.96875 0.40625 0.19531 0 0.375-0.035156 0.53125-0.10938-0.17969-0.11328-0.35156-0.1875-0.51562-0.21875l0.125-0.39062c0.32031 0.09375 0.57031 0.22656 0.75 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.1406-1.9062h-0.875v2.2812h-0.40625v-5h0.40625v2.2969h0.875zm-2.0781-0.35938c0 0.46875-0.12109 0.87109-0.35938 1.2031-0.24219 0.32422-0.53125 0.48438-0.875 0.48438s-0.63672-0.16016-0.875-0.48438c-0.24219-0.32031-0.35938-0.72266-0.35938-1.2031 0-0.48828 0.11328-0.89062 0.34375-1.2031 0.23828-0.3125 0.53516-0.46875 0.89062-0.46875 0.34375 0 0.63281 0.16797 0.875 0.5 0.23828 0.32422 0.35938 0.71484 0.35938 1.1719zm-0.40625 0.015625c0-0.34375-0.085938-0.63281-0.25-0.875-0.15625-0.25-0.35156-0.375-0.57812-0.375-0.23047 0-0.42969 0.125-0.59375 0.375-0.15625 0.24219-0.23438 0.53125-0.23438 0.875s0.078125 0.63672 0.23438 0.875c0.16406 0.24219 0.36328 0.35938 0.59375 0.35938 0.22656 0 0.42188-0.11719 0.57812-0.35938 0.16406-0.23828 0.25-0.53125 0.25-0.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844 0.375h-0.42188v-5h0.42188zm-1.4375-2.6406c0 0.53125-0.13281 0.96875-0.39062 1.3125-0.26172 0.33594-0.59375 0.5-1 0.5-0.42969 0-0.77344-0.16016-1.0312-0.48438-0.26172-0.33203-0.39062-0.77344-0.39062-1.3281 0-0.55078 0.12891-0.98438 0.39062-1.2969 0.25781-0.32031 0.60156-0.48438 1.0312-0.48438 0.40625 0 0.73828 0.16797 1 0.5 0.25781 0.32422 0.39062 0.75 0.39062 1.2812zm-0.45312 0.015625c0-0.38281-0.089844-0.70703-0.26562-0.96875-0.16797-0.25781-0.39062-0.39062-0.67188-0.39062s-0.51562 0.13672-0.70312 0.40625c-0.17969 0.26172-0.26562 0.57812-0.26562 0.95312 0 0.36719 0.085938 0.68359 0.26562 0.95312 0.1875 0.26172 0.42188 0.39062 0.70312 0.39062 0.26953 0 0.49219-0.12891 0.67188-0.39062 0.17578-0.25781 0.26562-0.57812 0.26562-0.95312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844 0.375h-0.40625v-5h0.40625zm-1.1875-1.4219c-0.4375 0.085937-0.98438 0.15234-1.6406 0.20312-0.65625 0.054688-1.1484 0.078125-1.4688 0.078125v-3.2344h2.875v0.4375h-2.4375v0.84375h2.3281v0.4375h-2.3281v1.0625c1-0.03125 1.8906-0.10938 2.6719-0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844-1.7188h-0.40625v-2.9219h0.40625zm-0.82812-0.03125h-0.42188v-1.1406h-0.73438v-0.4375h0.73438v-1.1875h0.42188zm-1.3438-1.3594c0 0.32422-0.10938 0.59375-0.32812 0.8125-0.21875 0.21094-0.51172 0.3125-0.875 0.3125-0.36719 0-0.65625-0.10156-0.875-0.3125-0.21875-0.20703-0.32812-0.47266-0.32812-0.79688 0-0.33203 0.11328-0.60156 0.34375-0.8125 0.22656-0.21875 0.51562-0.32812 0.85938-0.32812 0.35156 0 0.64062 0.10938 0.85938 0.32812 0.22656 0.21875 0.34375 0.48438 0.34375 0.79688zm-0.42188 0c0-0.19531-0.078125-0.36328-0.23438-0.5-0.14844-0.14453-0.32812-0.21875-0.54688-0.21875s-0.40625 0.074219-0.5625 0.21875c-0.15625 0.13672-0.23438 0.30469-0.23438 0.5 0 0.19922 0.078125 0.37109 0.23438 0.51562 0.15625 0.13672 0.34375 0.20312 0.5625 0.20312s0.39844-0.066406 0.54688-0.20312c0.15625-0.14453 0.23438-0.31641 0.23438-0.51562zm2.1875 3.4375v-1.3438h-3.1719v-0.4375h3.5781v1.7812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.875-3.4062c0.16406 0.29297 0.45703 0.58984 0.875 0.89062 0.42578 0.29297 0.84766 0.49219 1.2656 0.59375-0.16797 0.15625-0.28125 0.30469-0.34375 0.4375-0.36719-0.13281-0.74219-0.33594-1.125-0.60938-0.375-0.28125-0.66406-0.55469-0.85938-0.82812-0.46094 0.6875-1.0859 1.1836-1.875 1.4844-0.085938-0.15625-0.18359-0.27344-0.29688-0.35938 0.625-0.20703 1.1133-0.51562 1.4688-0.92188 0.35156-0.41406 0.53125-0.86719 0.53125-1.3594l0.60938 0.10938c-0.085938 0.11719-0.16797 0.30469-0.25 0.5625zm2.3125 3.125h-4.875v-0.4375h4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5156-3.9844c0.00781 0.9375-0.10156 1.9297-0.32812 2.9688-0.085938 0-0.24609-0.00781-0.48438-0.03125 0.070313-0.28906 0.14453-0.69141 0.21875-1.2031-1.4922 0.16797-2.4492 0.25781-2.875 0.26562l-0.10938-0.51562c0.70703 0 1.7227-0.050781 3.0469-0.15625 0.039063-0.36328 0.054687-0.66016 0.046875-0.89062h-2.9844v-0.4375zm0.67188 3.8594h-4.8438v-0.4375h2.1875v-1.1875h0.42188v1.1875h2.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844 0.375h-0.40625v-5h0.40625zm-4.1875-0.5625v-2.375h2.4062v-1.0625h-2.4219v-0.45312h2.8594v1.9375h-2.4062v1.5c1.0078-0.039063 1.9453-0.17188 2.8125-0.39062l0.015625 0.45312c-0.84375 0.21094-1.9336 0.33984-3.2656 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5625 0.39062v-2.625h-1.6406v-0.4375h1.6406v-1.9531h0.42188v5.0156zm-1.4531-0.84375c-0.49219-0.41406-0.88281-0.99219-1.1719-1.7344-0.30469 0.77344-0.71875 1.4062-1.25 1.9062-0.13672-0.21875-0.25781-0.35156-0.35938-0.40625 0.40625-0.26953 0.73828-0.67969 1-1.2344 0.25781-0.5625 0.39062-1.0625 0.39062-1.5l-0.015625-0.45312c0-0.11328-0.00781-0.20703-0.015625-0.28125l0.59375 0.0625c-0.11719 0.21875-0.17188 0.61719-0.17188 1.1875 0 0.074219 0.0625 0.24609 0.1875 0.51562 0.125 0.26172 0.24219 0.48047 0.35938 0.65625 0.11328 0.17969 0.23828 0.34375 0.375 0.5 0.13281 0.14844 0.27344 0.27734 0.42188 0.39062-0.15625 0.10547-0.27344 0.23438-0.34375 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5625-3.5469c0 0.24219-0.17188 0.45312-0.51562 0.64062-0.34375 0.17969-0.77734 0.26562-1.2969 0.26562-0.53125 0-0.96875-0.082031-1.3125-0.25-0.33594-0.17578-0.5-0.39453-0.5-0.65625 0-0.23828 0.17578-0.44531 0.53125-0.625 0.35156-0.17578 0.78125-0.26562 1.2812-0.26562s0.92578 0.089844 1.2812 0.26562c0.35156 0.17969 0.53125 0.38672 0.53125 0.625zm-0.51562 0c0-0.13281-0.125-0.25-0.375-0.34375-0.24219-0.09375-0.54688-0.14062-0.92188-0.14062-0.36719 0-0.67188 0.046875-0.92188 0.14062s-0.375 0.21094-0.375 0.34375c0 0.13672 0.125 0.25 0.375 0.34375s0.55469 0.14062 0.92188 0.14062c0.375 0 0.67969-0.046875 0.92188-0.14062 0.25-0.09375 0.375-0.20703 0.375-0.34375zm1.0156 1.5312h-2.1094v0.375h-0.40625v-0.375h-2.1094v-0.42188h4.625zm-0.625 0.46875v1.0938h-2.9844v0.35938h3.0625v0.4375h-3.5v-1.2188h3v-0.25h-3v-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844 0.375h-0.40625v-5h0.40625zm-1.3906-1.0469c-0.54297-0.40625-0.98438-0.98438-1.3281-1.7344-0.33594 0.78125-0.79688 1.418-1.3906 1.9062-0.14844-0.1875-0.27344-0.30469-0.375-0.35938 0.45703-0.28906 0.82812-0.70703 1.1094-1.25 0.28906-0.55078 0.4375-1.0508 0.4375-1.5 0-0.34375-0.011719-0.57031-0.03125-0.6875l0.625 0.0625c-0.0625 0.14844-0.10938 0.28906-0.14062 0.42188-0.023438 0.125-0.03125 0.375-0.03125 0.75 0 0.054688 0.050781 0.1875 0.15625 0.40625 0.10156 0.21094 0.20312 0.38672 0.29688 0.53125 0.09375 0.14844 0.19531 0.28906 0.3125 0.42188 0.11328 0.13672 0.22656 0.26172 0.34375 0.375 0.125 0.10547 0.25391 0.20312 0.39062 0.29688-0.16797 0.10547-0.29297 0.22656-0.375 0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.1406-2.9531h-0.875v1.25h-0.40625v-2.9062h0.40625v1.2344h0.875zm-4.375 1.2344-0.28125-0.35938c0.4375-0.14453 0.83594-0.39062 1.2031-0.73438 0.375-0.35156 0.61719-0.70703 0.73438-1.0625h-1.7656v-0.42188h2.375c-0.10547 0.5625-0.35938 1.0742-0.76562 1.5312-0.40625 0.46094-0.90625 0.80859-1.5 1.0469zm3.625 1.0938c0 0.30469-0.15625 0.54297-0.46875 0.71875-0.30469 0.1875-0.69531 0.28125-1.1719 0.28125-0.5 0-0.90625-0.089844-1.2188-0.26562-0.30469-0.16406-0.45312-0.40625-0.45312-0.71875 0-0.28125 0.15625-0.51953 0.46875-0.71875 0.3125-0.19531 0.71094-0.29688 1.2031-0.29688 0.47656 0 0.86719 0.09375 1.1719 0.28125 0.3125 0.1875 0.46875 0.42969 0.46875 0.71875zm-0.5 0.03125c0-0.17578-0.10547-0.31641-0.3125-0.42188-0.21094-0.10156-0.48438-0.15625-0.82812-0.15625-0.35547 0-0.64062 0.054687-0.85938 0.15625-0.21094 0.10547-0.3125 0.24219-0.3125 0.40625 0 0.16797 0.10156 0.30469 0.3125 0.40625 0.21875 0.10547 0.50391 0.15625 0.85938 0.15625 0.34375 0 0.61719-0.050781 0.82812-0.15625 0.20703-0.10156 0.3125-0.23438 0.3125-0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.1406-2.9844h-0.875v1.2812h-0.40625v-2.9219h0.40625v1.2188h0.875zm-4.1094-1.1094v1.5156c0.58203 0.023437 1.4219-0.035156 2.5156-0.17188v0.42188c-0.90625 0.10547-1.8906 0.16797-2.9531 0.1875v-1.9531zm2.8281 4.4219v-0.17188h-2.25v0.1875h-0.42188v-1.8906h3.0781v1.875zm0-1.4531h-2.25v0.84375h2.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.0625-1.8438h-2.1094v2.2031h-0.40625v-2.2031h-2.1094v-0.4375h3.3438c0.16406-0.84375 0.25-1.3633 0.25-1.5625h-3.2344v-0.4375h3.7188c-0.011719 0.33594-0.10938 1-0.29688 2h0.84375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5-1.7031h-0.42188v-0.82812h-1.1094v-0.42188h1.1094v-0.40625h-1.1094v-0.4375h1.1094v-0.82812h0.42188zm-1.9844-1.4062c0 0.33594-0.12109 0.61719-0.35938 0.84375-0.23047 0.23047-0.53125 0.34375-0.90625 0.34375-0.38672 0-0.69531-0.10938-0.92188-0.32812-0.23047-0.22656-0.34375-0.51953-0.34375-0.875 0-0.32031 0.11719-0.59766 0.35938-0.82812 0.23828-0.22656 0.53906-0.34375 0.90625-0.34375 0.375 0 0.67578 0.11719 0.90625 0.34375 0.23828 0.23047 0.35938 0.51172 0.35938 0.84375zm-0.40625 0c0-0.20703-0.085937-0.39062-0.25-0.54688-0.16797-0.15625-0.37109-0.23438-0.60938-0.23438-0.23047 0-0.42969 0.078125-0.59375 0.23438-0.16797 0.15625-0.25 0.33984-0.25 0.54688 0 0.21094 0.082031 0.39062 0.25 0.54688 0.16406 0.14844 0.36328 0.21875 0.59375 0.21875 0.23828 0 0.44141-0.070312 0.60938-0.21875 0.16406-0.15625 0.25-0.33594 0.25-0.54688zm2.4062 2.5c0 0.3125-0.17188 0.55469-0.51562 0.71875-0.34375 0.17578-0.79297 0.26562-1.3438 0.26562-0.5625 0-1.0156-0.089844-1.3594-0.26562-0.34375-0.16406-0.51562-0.40625-0.51562-0.71875 0-0.30078 0.17969-0.53906 0.54688-0.71875 0.36328-0.1875 0.80469-0.28125 1.3281-0.28125 0.53906 0 0.98438 0.089844 1.3281 0.26562 0.35156 0.17969 0.53125 0.42188 0.53125 0.73438zm-0.45312 0c0-0.15625-0.14062-0.28516-0.42188-0.39062-0.27344-0.11328-0.60156-0.17188-0.98438-0.17188-0.375 0-0.71094 0.054687-1 0.15625-0.28125 0.09375-0.42188 0.23047-0.42188 0.40625 0 0.15625 0.14844 0.29297 0.45312 0.40625 0.30078 0.10547 0.625 0.15625 0.96875 0.15625 0.38281 0 0.71094-0.050781 0.98438-0.15625 0.28125-0.11328 0.42188-0.25 0.42188-0.40625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.0625-1.8281h-4.625v-0.39062h2.1094v-0.39062h-1.5781v-1.7344h3.4844v0.4375h-3.0469v0.85938h3.1094v0.4375h-1.5625v0.39062h2.1094zm-0.45312 1.2188c0 0.3125-0.17188 0.55469-0.51562 0.71875-0.34375 0.17578-0.78906 0.26562-1.3281 0.26562-0.57422 0-1.0312-0.089844-1.375-0.26562-0.33594-0.16406-0.5-0.40625-0.5-0.71875 0-0.30078 0.17969-0.53906 0.54688-0.71875 0.36328-0.1875 0.80469-0.28125 1.3281-0.28125 0.53906 0 0.98438 0.089844 1.3281 0.26562 0.34375 0.17969 0.51562 0.42188 0.51562 0.73438zm-1.7969-0.5625c-0.41797 0-0.76562 0.054687-1.0469 0.15625-0.28125 0.09375-0.42188 0.23047-0.42188 0.40625 0 0.15625 0.14453 0.29297 0.4375 0.40625 0.30078 0.10547 0.62891 0.15625 0.98438 0.15625 0.375 0 0.69531-0.050781 0.96875-0.15625 0.28125-0.11328 0.42188-0.25 0.42188-0.40625s-0.13281-0.28516-0.39062-0.39062c-0.26172-0.11328-0.57812-0.17188-0.95312-0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9844 0.375h-0.40625v-2.3438h-0.6875v2.0469h-0.42188v-4.4375h0.42188v1.9688h0.6875v-2.2344h0.40625zm-2.0938-3.7969h-1.8594v2.5312c0.5625 0 1.2891-0.066406 2.1875-0.20312v0.42188c-0.82422 0.125-1.6992 0.20312-2.625 0.23438v-3.4219h2.2969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.1875-0.14062h-4.8438v-0.4375h2.1875v-0.875h-1.5156v-1.5781h2.9219v-0.6875h-2.9219v-0.4375h3.3594v1.5625h-2.9219v0.70312h3.0625v0.4375h-1.5625v0.875h2.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5312-1.3438h-3.5156v-2.6094h3.4688v0.4375h-3.0156v0.65625h2.8438v0.42188h-2.8438v0.65625h3.0625zm0.65625 1.0625h-4.875v-0.4375h4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5781 0.375v-5.0156h0.40625v5.0156zm-1.0312-0.29688v-1.9844h-0.73438v-0.42188h0.73438v-2.2188h0.42188v4.625zm-2.8906-0.29688v-2.5156h1.6406v-1h-1.6406v-0.4375h2.0781v1.875h-1.6406v1.625c0.58203-0.007813 1.2227-0.10156 1.9219-0.28125v0.42188c-0.65625 0.17969-1.4453 0.28125-2.3594 0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4531-3.4688h-3.0469v1.5312h3.1094c0.00781 0.11719 0.00781 0.26172 0 0.4375h-3.5469v-2.4062h3.4844zm0.73438 3.2344h-4.875v-0.4375h4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5781-0.90625v-3.7188h0.42188v3.7188zm-0.9375-0.3125v-1.7188h-0.95312v-0.42188h0.95312v-1.1719h0.42188v3.3125zm-1.6094-2.1406c0.082031 0.26172 0.25391 0.54688 0.51562 0.85938 0.26953 0.3125 0.53906 0.54297 0.8125 0.6875-0.14844 0.0625-0.27734 0.18359-0.39062 0.35938-0.40625-0.28906-0.79297-0.72266-1.1562-1.2969-0.24219 0.51172-0.625 0.96484-1.1562 1.3594-0.10547-0.15625-0.21875-0.28125-0.34375-0.375 0.33203-0.19531 0.60938-0.4375 0.82812-0.71875 0.22656-0.28906 0.375-0.55469 0.4375-0.79688 0.070313-0.25 0.10938-0.56641 0.10938-0.95312l0.51562 0.0625c-0.03125 0.074219-0.070313 0.22656-0.10938 0.45312-0.042969 0.23047-0.0625 0.35156-0.0625 0.35938zm2.9531 3.6094h-3.6406v-1.6719h0.42188v1.2344h3.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5781 0.39062v-2.2969h-1.2344v-0.42188h1.2344v-2.2969h0.40625v5.0156zm-1.0469-1.1719c-0.40625 0.0625-0.91797 0.12109-1.5312 0.17188-0.61719 0.042969-1.0703 0.0625-1.3594 0.0625v-3.4219h2.6562v0.42188h-2.2188v0.96875h2.0938v0.4375h-2.0938v1.1719c0.63281 0 1.4531-0.078125 2.4531-0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5625-3.9844h-1.625v-0.42188h1.625zm1.25 1.2812-0.42188 0.4375c-0.71875-0.16406-1.2734-0.45312-1.6562-0.85938-0.41797 0.42969-0.97656 0.71875-1.6719 0.875-0.13672-0.21875-0.25-0.35938-0.34375-0.42188 0.76953-0.13281 1.2852-0.34766 1.5469-0.64062h-1.4844v-0.4375h3.9375v0.4375h-1.5c0.32031 0.30469 0.85156 0.50781 1.5938 0.60938zm0.25 0.95312h-4.625v-0.42188h4.6406zm-0.45312 1.1406c0 0.3125-0.17188 0.55469-0.51562 0.71875-0.34375 0.17578-0.78906 0.26562-1.3281 0.26562-0.57422 0-1.0312-0.089844-1.375-0.26562-0.33594-0.16406-0.5-0.40625-0.5-0.71875 0-0.30078 0.17969-0.53906 0.54688-0.71875 0.36328-0.1875 0.80469-0.28125 1.3281-0.28125 0.53906 0 0.98438 0.089844 1.3281 0.26562 0.34375 0.17969 0.51562 0.42188 0.51562 0.73438zm-1.7969-0.5625c-0.41797 0-0.76562 0.054687-1.0469 0.15625-0.28125 0.09375-0.42188 0.23047-0.42188 0.40625 0 0.15625 0.14453 0.29297 0.4375 0.40625 0.30078 0.10547 0.62891 0.15625 0.98438 0.15625 0.375 0 0.69531-0.050781 0.96875-0.15625 0.28125-0.11328 0.42188-0.25 0.42188-0.40625s-0.13281-0.28516-0.39062-0.39062c-0.26172-0.11328-0.57812-0.17188-0.95312-0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.71875-2.0312c0.21875-0.34375 0.53516-0.51562 0.95312-0.51562 0.32031 0 0.59375 0.12109 0.8125 0.35938 0.22656 0.23047 0.34375 0.53125 0.34375 0.90625s-0.11719 0.69531-0.34375 0.95312c-0.21875 0.26172-0.51562 0.39062-0.89062 0.39062s-0.69922-0.13281-0.96875-0.40625c-0.26172-0.28125-0.39062-0.78125-0.39062-1.5 0-0.69531 0.11719-1.2227 0.35938-1.5781 0.23828-0.35156 0.58594-0.53125 1.0469-0.53125 0.28906 0 0.53516 0.085937 0.73438 0.25 0.20703 0.15625 0.33594 0.40234 0.39062 0.73438l-0.48438 0.03125c-0.09375-0.41406-0.32031-0.625-0.67188-0.625-0.25 0-0.46484 0.125-0.64062 0.375-0.17969 0.24219-0.26562 0.625-0.26562 1.1562zm0.85938 1.7031c0.22656 0 0.41016-0.085937 0.54688-0.26562 0.13281-0.1875 0.20312-0.40625 0.20312-0.65625s-0.070313-0.45703-0.20312-0.625c-0.13672-0.16406-0.32422-0.25-0.5625-0.25-0.21094 0-0.39062 0.078125-0.54688 0.23438s-0.23438 0.35938-0.23438 0.60938c0 0.26172 0.070312 0.48438 0.21875 0.67188 0.15625 0.1875 0.34766 0.28125 0.57812 0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-7-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0938-3.4688h-2.125v1.2188h1.8438v0.46875h-1.8438v1.7812h-0.53125v-3.9375h2.6562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-1.25c-0.11719 0.44922-0.3125 0.78125-0.59375 1-0.28125 0.21094-0.625 0.3125-1.0312 0.3125-0.64844 0-1.1172-0.19531-1.4062-0.59375-0.29297-0.40625-0.4375-0.89453-0.4375-1.4688 0-0.625 0.17188-1.1133 0.51562-1.4688 0.34375-0.35156 0.78906-0.53125 1.3438-0.53125 0.375 0 0.69531 0.10156 0.96875 0.29688 0.28125 0.1875 0.47266 0.46875 0.57812 0.84375l-0.5 0.125c-0.09375-0.26953-0.23047-0.47266-0.40625-0.60938-0.16797-0.14453-0.38672-0.21875-0.65625-0.21875-0.42969 0-0.75781 0.14062-0.98438 0.42188-0.21875 0.28125-0.32812 0.66406-0.32812 1.1406 0 0.55469 0.11328 0.96484 0.34375 1.2344 0.23828 0.26172 0.54688 0.39062 0.92188 0.39062 0.3125 0 0.5625-0.082031 0.75-0.25 0.19531-0.16406 0.33203-0.41406 0.40625-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0469 0h-0.5625v-0.54688h0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0312 0h-0.53125v-3.9375h0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0938-3.4688h-2.125v1.2188h1.8438v0.46875h-1.8438v1.7812h-0.53125v-3.9375h2.6562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6719 0h-0.59375l-0.45312-1.2031h-1.6406l-0.4375 1.2031h-0.54688l1.5-3.9375h0.5625zm-1.2031-1.6094c-0.32422-0.85156-0.50781-1.3359-0.54688-1.4531-0.042969-0.11328-0.089844-0.26953-0.14062-0.46875h-0.015625c-0.054687 0.27344-0.12109 0.51562-0.20312 0.73438l-0.4375 1.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562-1.1875h-1.4844v-0.48438h1.4844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0625 0h-0.48438v-3.0781c-0.24219 0.23047-0.5625 0.42188-0.96875 0.57812v-0.46875c0.55078-0.25781 0.92969-0.58594 1.1406-0.98438h0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.875-2.3594c0.23828-0.16406 0.48438-0.25 0.73438-0.25 0.33203 0 0.61719 0.11719 0.85938 0.34375 0.25 0.23047 0.375 0.53906 0.375 0.92188 0 0.39844-0.125 0.73047-0.375 1-0.25 0.27344-0.57422 0.40625-0.96875 0.40625-0.33594 0-0.62109-0.085938-0.85938-0.26562-0.24219-0.1875-0.375-0.46094-0.40625-0.82812l0.5-0.046875c0.039063 0.25 0.12891 0.4375 0.26562 0.5625 0.13281 0.125 0.30078 0.1875 0.5 0.1875 0.23828 0 0.4375-0.09375 0.59375-0.28125s0.23438-0.41406 0.23438-0.6875c0-0.26953-0.078125-0.48438-0.23438-0.64062-0.15625-0.16406-0.35938-0.25-0.60938-0.25-0.3125 0-0.55469 0.125-0.71875 0.375l-0.45312-0.046875 0.39062-2.0312h1.9531v0.46875h-1.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0781-2.125c0.25 0.042969 0.4375 0.15625 0.5625 0.34375s0.1875 0.39844 0.1875 0.625c0 0.35547-0.13281 0.64844-0.39062 0.875-0.26172 0.23047-0.57422 0.34375-0.9375 0.34375-0.35547 0-0.64844-0.097656-0.875-0.29688-0.21875-0.20703-0.35156-0.47656-0.39062-0.8125l0.48438-0.0625c0.050781 0.26172 0.14062 0.46094 0.26562 0.59375 0.13281 0.125 0.30469 0.1875 0.51562 0.1875 0.21875 0 0.40625-0.078125 0.5625-0.23438 0.15625-0.16406 0.23438-0.36328 0.23438-0.59375 0-0.21875-0.074219-0.39844-0.21875-0.54688-0.13672-0.14453-0.32031-0.21875-0.54688-0.21875-0.09375 0-0.21094 0.023437-0.34375 0.0625l0.0625-0.42188c0.125 0 0.22266-0.00391 0.29688-0.015625 0.082031-0.019531 0.17188-0.050781 0.26562-0.09375 0.09375-0.050781 0.16406-0.11719 0.21875-0.20312 0.0625-0.09375 0.09375-0.20703 0.09375-0.34375 0-0.19531-0.070312-0.34766-0.20312-0.45312-0.125-0.11328-0.27344-0.17188-0.4375-0.17188-0.19922 0-0.35938 0.0625-0.48438 0.1875-0.11719 0.125-0.1875 0.30469-0.21875 0.53125l-0.48438-0.09375c0.0625-0.34375 0.19531-0.59766 0.40625-0.76562 0.21875-0.16406 0.47266-0.25 0.76562-0.25 0.33203 0 0.60938 0.10156 0.82812 0.29688 0.21875 0.19922 0.32812 0.4375 0.32812 0.71875 0 0.375-0.18359 0.64062-0.54688 0.79688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7969-0.9375h-0.53125v0.9375h-0.48438v-0.9375h-1.7031v-0.45312l1.7969-2.5469h0.39062v2.5469h0.53125zm-1.0156-0.45312v-1.7656l-1.2188 1.7656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5312-3.9531c0.85156 0 1.2812 0.67188 1.2812 2.0156 0 0.67969-0.10938 1.1836-0.32812 1.5156-0.21875 0.32422-0.53906 0.48438-0.95312 0.48438-0.85547 0-1.2812-0.66406-1.2812-2 0-0.67578 0.10938-1.1797 0.32812-1.5156 0.21875-0.33203 0.53516-0.5 0.95312-0.5zm0 3.625c0.25781 0 0.45312-0.125 0.57812-0.375 0.13281-0.25 0.20312-0.66016 0.20312-1.2344 0-0.39453-0.03125-0.70703-0.09375-0.9375-0.054688-0.22656-0.14062-0.39844-0.26562-0.51562-0.11719-0.11328-0.26172-0.17188-0.4375-0.17188-0.25 0-0.44531 0.13281-0.57812 0.39062-0.13672 0.25-0.20312 0.66406-0.20312 1.2344 0 0.38672 0.03125 0.69531 0.09375 0.92188 0.0625 0.23047 0.14844 0.40234 0.26562 0.51562 0.11328 0.11719 0.25781 0.17188 0.4375 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.71875-2.0312c0.21875-0.34375 0.53516-0.51562 0.95312-0.51562 0.32031 0 0.59375 0.12109 0.8125 0.35938 0.22656 0.23047 0.34375 0.53125 0.34375 0.90625s-0.11719 0.69531-0.34375 0.95312c-0.21875 0.26172-0.51562 0.39062-0.89062 0.39062s-0.69922-0.13281-0.96875-0.40625c-0.26172-0.28125-0.39062-0.78125-0.39062-1.5 0-0.69531 0.11719-1.2227 0.35938-1.5781 0.23828-0.35156 0.58594-0.53125 1.0469-0.53125 0.28906 0 0.53516 0.085937 0.73438 0.25 0.20703 0.15625 0.33594 0.40234 0.39062 0.73438l-0.48438 0.03125c-0.09375-0.41406-0.32031-0.625-0.67188-0.625-0.25 0-0.46484 0.125-0.64062 0.375-0.17969 0.24219-0.26562 0.625-0.26562 1.1562zm0.85938 1.7031c0.22656 0 0.41016-0.085937 0.54688-0.26562 0.13281-0.1875 0.20312-0.40625 0.20312-0.65625s-0.070313-0.45703-0.20312-0.625c-0.13672-0.16406-0.32422-0.25-0.5625-0.25-0.21094 0-0.39062 0.078125-0.54688 0.23438s-0.23438 0.35938-0.23438 0.60938c0 0.26172 0.070312 0.48438 0.21875 0.67188 0.15625 0.1875 0.34766 0.28125 0.57812 0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.42188-3.9375h1.4844c0.23828 0 0.44141 0.011719 0.60938 0.03125 0.16406 0.023438 0.32031 0.085938 0.46875 0.1875 0.14453 0.09375 0.25391 0.22656 0.32812 0.39062 0.070312 0.16797 0.10938 0.34375 0.10938 0.53125 0 0.36719-0.12109 0.65625-0.35938 0.875-0.23047 0.21875-0.60156 0.32812-1.1094 0.32812h-1v1.5938h-0.53125zm0.53125 1.875h1c0.625 0 0.9375-0.23828 0.9375-0.71875 0-0.15625-0.042969-0.28906-0.125-0.40625-0.085937-0.125-0.18359-0.20312-0.29688-0.23438-0.11719-0.03125-0.28906-0.046875-0.51562-0.046875h-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.875 0h-2.4688v-3.9375h0.53125v3.4688h1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2344-3.4688h-1.2969v3.4688h-0.53125v-3.4688h-1.2812v-0.46875h3.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375-3.9375h1.3594c0.23828 0 0.44141 0.015625 0.60938 0.046875 0.17578 0.023437 0.34375 0.078125 0.5 0.17188s0.28906 0.22656 0.40625 0.39062c0.125 0.15625 0.21875 0.34375 0.28125 0.5625 0.070312 0.21094 0.10938 0.46875 0.10938 0.78125 0 0.57422-0.14062 1.0469-0.42188 1.4219-0.27344 0.375-0.74609 0.5625-1.4219 0.5625h-1.4219zm0.53125 3.4688h0.84375c0.16406 0 0.31641-0.007812 0.45312-0.03125 0.13281-0.019531 0.26953-0.078125 0.40625-0.17188 0.14453-0.09375 0.25781-0.25 0.34375-0.46875 0.09375-0.21875 0.14062-0.50391 0.14062-0.85938 0-0.19531-0.023438-0.37891-0.0625-0.54688-0.03125-0.17578-0.09375-0.33203-0.1875-0.46875-0.09375-0.14453-0.20312-0.25-0.32812-0.3125-0.11719-0.0625-0.23047-0.097656-0.34375-0.10938-0.11719-0.019531-0.26562-0.03125-0.45312-0.03125h-0.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9062 0h-0.65625c-0.38672-0.61328-0.63281-0.99219-0.73438-1.1406-0.09375-0.14453-0.19531-0.26562-0.29688-0.35938-0.10547-0.10156-0.20312-0.16406-0.29688-0.1875-0.085937-0.03125-0.20312-0.046875-0.35938-0.046875h-0.59375v1.7344h-0.53125v-3.9375h1.75c0.23828 0 0.4375 0.015625 0.59375 0.046875 0.16406 0.03125 0.30469 0.10156 0.42188 0.20312 0.125 0.09375 0.21875 0.21484 0.28125 0.35938 0.0625 0.14844 0.09375 0.30469 0.09375 0.46875 0 0.29297-0.09375 0.53125-0.28125 0.71875-0.1875 0.17969-0.46094 0.29297-0.8125 0.34375v0.015625c0.25781 0.11719 0.50391 0.35156 0.73438 0.70312zm-2.9375-2.2031h1.1094c0.22656 0 0.40625-0.019531 0.53125-0.0625 0.13281-0.039063 0.23828-0.11328 0.3125-0.21875 0.082031-0.11328 0.125-0.23828 0.125-0.375 0-0.17578-0.070313-0.32812-0.20312-0.45312-0.125-0.125-0.33984-0.1875-0.64062-0.1875h-1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5312-1.6562c0 0.19922-0.011719 0.38672-0.03125 0.5625-0.023438 0.16797-0.085938 0.34375-0.1875 0.53125-0.09375 0.17969-0.25 0.32812-0.46875 0.45312-0.21094 0.11328-0.49609 0.17188-0.85938 0.17188-0.34375 0-0.625-0.054688-0.84375-0.15625-0.21875-0.10156-0.38281-0.23828-0.48438-0.40625-0.09375-0.17578-0.15625-0.35156-0.1875-0.53125-0.023438-0.1875-0.03125-0.39453-0.03125-0.625v-2.2812h0.51562v2.2656c0 0.24219 0.015625 0.44922 0.046875 0.625 0.039062 0.16797 0.13281 0.32031 0.28125 0.45312 0.14453 0.125 0.36719 0.1875 0.67188 0.1875 0.30078 0 0.53125-0.050781 0.6875-0.15625 0.15625-0.10156 0.25391-0.24219 0.29688-0.42188 0.050781-0.17578 0.078125-0.40625 0.078125-0.6875v-2.2656h0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0781-2.125c0.5 0.15625 0.75 0.49219 0.75 1 0 0.34375-0.125 0.63281-0.375 0.85938-0.24219 0.21875-0.54688 0.32812-0.92188 0.32812-0.38672 0-0.69922-0.11328-0.9375-0.34375-0.24219-0.22656-0.35938-0.51562-0.35938-0.85938 0-0.25 0.066406-0.46875 0.20312-0.65625 0.13281-0.1875 0.31641-0.29688 0.54688-0.32812v-0.015625c-0.39844-0.125-0.59375-0.39062-0.59375-0.79688 0-0.28906 0.10156-0.53125 0.3125-0.71875 0.20703-0.19531 0.47656-0.29688 0.8125-0.29688 0.34375 0 0.61719 0.10156 0.82812 0.29688 0.20703 0.19922 0.3125 0.44531 0.3125 0.73438 0 0.38672-0.19531 0.64844-0.57812 0.78125zm-0.54688-0.20312c0.17578 0 0.32812-0.054687 0.45312-0.17188 0.125-0.11328 0.1875-0.25391 0.1875-0.42188 0-0.17578-0.0625-0.32812-0.1875-0.45312s-0.28125-0.1875-0.46875-0.1875c-0.17969 0-0.32812 0.0625-0.45312 0.1875-0.11719 0.11719-0.17188 0.25781-0.17188 0.42188 0 0.19922 0.054687 0.35547 0.17188 0.46875 0.125 0.10547 0.28125 0.15625 0.46875 0.15625zm0 2c0.22656 0 0.41406-0.070313 0.5625-0.21875 0.15625-0.14453 0.23438-0.33594 0.23438-0.57812 0-0.22656-0.078125-0.41406-0.23438-0.5625-0.15625-0.15625-0.35156-0.23438-0.57812-0.23438-0.23047 0-0.42188 0.078125-0.57812 0.23438-0.14844 0.14844-0.21875 0.32812-0.21875 0.54688 0 0.23047 0.070312 0.42188 0.21875 0.57812 0.15625 0.15625 0.35156 0.23438 0.59375 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3281-1.8594c-0.09375 0.15625-0.22656 0.28125-0.39062 0.375-0.16797 0.09375-0.34375 0.14062-0.53125 0.14062-0.32422 0-0.60156-0.11328-0.82812-0.34375-0.23047-0.23828-0.34375-0.55078-0.34375-0.9375 0-0.38281 0.11328-0.70312 0.34375-0.95312 0.22656-0.25 0.52344-0.375 0.89062-0.375 0.36328 0 0.67969 0.14062 0.95312 0.42188 0.26953 0.28125 0.40625 0.77734 0.40625 1.4844 0 0.71094-0.125 1.2422-0.375 1.5938-0.24219 0.34375-0.58984 0.51562-1.0469 0.51562-0.29297 0-0.53906-0.078125-0.73438-0.23438-0.19922-0.16406-0.32031-0.41016-0.35938-0.73438l0.45312-0.046875c0.070313 0.41797 0.28906 0.625 0.65625 0.625 0.30078 0 0.53125-0.13281 0.6875-0.40625 0.15625-0.26953 0.23438-0.64453 0.23438-1.125zm-0.8125 0.09375c0.23828 0 0.42578-0.082031 0.5625-0.25 0.13281-0.16406 0.20312-0.375 0.20312-0.625 0-0.25781-0.074219-0.47656-0.21875-0.65625-0.13672-0.17578-0.3125-0.26562-0.53125-0.26562-0.23047 0-0.42188 0.09375-0.57812 0.28125-0.14844 0.1875-0.21875 0.41406-0.21875 0.67188 0 0.25 0.070313 0.45312 0.21875 0.60938 0.15625 0.15625 0.34375 0.23438 0.5625 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812 0h-2.6094c0-0.21875 0.078125-0.44141 0.23438-0.67188 0.15625-0.22656 0.44141-0.51562 0.85938-0.85938 0.25781-0.20703 0.48828-0.42578 0.6875-0.65625 0.20703-0.22656 0.3125-0.45703 0.3125-0.6875 0-0.19531-0.074219-0.35938-0.21875-0.48438-0.13672-0.13281-0.30859-0.20312-0.51562-0.20312-0.21875 0-0.40234 0.070312-0.54688 0.20312-0.14844 0.13672-0.21875 0.33594-0.21875 0.59375l-0.5-0.046875c0.03125-0.375 0.16016-0.65625 0.39062-0.84375 0.22656-0.19531 0.51953-0.29688 0.875-0.29688 0.39453 0 0.69531 0.10938 0.90625 0.32812 0.21875 0.21094 0.32812 0.46484 0.32812 0.76562 0 0.25-0.09375 0.50781-0.28125 0.76562-0.17969 0.26172-0.53906 0.60547-1.0781 1.0312-0.28125 0.23047-0.46875 0.42969-0.5625 0.59375h1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1562 0h-0.48438v-3.2969h-0.015625l-1.125 3.2969h-0.46875l-1.1406-3.3438h-0.015625v3.3438h-0.48438v-3.9375h0.78125l0.92188 2.7812c0.10156 0.3125 0.16406 0.51172 0.1875 0.59375h0.015625c0.039063-0.15625 0.10938-0.36719 0.20312-0.64062l0.9375-2.7344h0.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406-4c0.55078 0 1.0039 0.1875 1.3594 0.5625 0.35156 0.375 0.53125 0.86719 0.53125 1.4688 0 0.61719-0.17969 1.1094-0.53125 1.4844-0.35547 0.36719-0.80859 0.54688-1.3594 0.54688-0.5625 0-1.0156-0.19141-1.3594-0.57812-0.34375-0.38281-0.51562-0.85156-0.51562-1.4062 0-0.64453 0.17188-1.1484 0.51562-1.5156 0.35156-0.375 0.80469-0.5625 1.3594-0.5625zm0 3.625c0.39453 0 0.71875-0.14062 0.96875-0.42188s0.375-0.67188 0.375-1.1719c0-0.50781-0.13281-0.89844-0.39062-1.1719-0.25-0.28125-0.5625-0.42188-0.9375-0.42188-0.39844 0-0.72656 0.13672-0.98438 0.40625-0.25 0.27344-0.375 0.6875-0.375 1.25 0 0.46094 0.125 0.82812 0.375 1.1094s0.57031 0.42188 0.96875 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0469-2.2969h-0.54688v-0.54688h0.54688zm0 2.2969h-0.54688v-0.54688h0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7656-2.7812c-0.023437-0.25-0.11719-0.4375-0.28125-0.5625-0.15625-0.125-0.38281-0.1875-0.67188-0.1875-0.27344 0-0.49609 0.054688-0.67188 0.15625-0.16797 0.09375-0.25 0.23438-0.25 0.42188 0 0.17969 0.0625 0.30859 0.1875 0.39062 0.13281 0.085938 0.39062 0.16406 0.76562 0.23438 0.32031 0.074219 0.58203 0.15234 0.78125 0.23438 0.20703 0.074219 0.38281 0.1875 0.53125 0.34375 0.15625 0.15625 0.23438 0.37109 0.23438 0.64062 0 0.33594-0.13672 0.61719-0.40625 0.84375-0.27344 0.21875-0.625 0.32812-1.0625 0.32812-0.55469 0-0.96875-0.11719-1.25-0.35938-0.27344-0.25-0.41406-0.57031-0.42188-0.96875l0.48438-0.046875c0.03125 0.32422 0.15625 0.55859 0.375 0.70312 0.21875 0.13672 0.48438 0.20312 0.79688 0.20312 0.28906 0 0.52344-0.054688 0.70312-0.17188 0.17578-0.125 0.26562-0.28906 0.26562-0.5 0-0.20703-0.09375-0.35938-0.28125-0.45312-0.1875-0.10156-0.50781-0.20312-0.95312-0.29688-0.4375-0.10156-0.75781-0.23828-0.95312-0.40625-0.1875-0.17578-0.28125-0.39844-0.28125-0.67188 0-0.32031 0.11719-0.58203 0.35938-0.78125 0.25-0.20703 0.58594-0.3125 1.0156-0.3125 0.4375 0 0.78516 0.10547 1.0469 0.3125 0.26953 0.19922 0.41406 0.48438 0.4375 0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4844 0c-0.14844 0.019531-0.26562 0.03125-0.35938 0.03125-0.21875 0-0.375-0.035156-0.46875-0.10938-0.09375-0.070313-0.15234-0.16406-0.17188-0.28125-0.023437-0.11328-0.03125-0.26953-0.03125-0.46875v-1.6406h-0.35938v-0.375h0.35938v-0.71875l0.46875-0.28125v1h0.48438v0.375h-0.48438v1.6562c0 0.14844 0.015625 0.25 0.046875 0.3125s0.10938 0.09375 0.23438 0.09375c0.0625 0 0.12891-0.007812 0.20312-0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8438-1.2969h-2.1406c0.019531 0.3125 0.10938 0.55469 0.26562 0.71875 0.16406 0.16797 0.36719 0.25 0.60938 0.25 0.1875 0 0.34375-0.046875 0.46875-0.14062 0.125-0.10156 0.21875-0.25391 0.28125-0.45312l0.5 0.0625c-0.085937 0.30469-0.23438 0.53125-0.45312 0.6875-0.21094 0.15625-0.47656 0.23438-0.79688 0.23438-0.42969 0-0.76172-0.12891-1-0.39062-0.24219-0.25781-0.35938-0.61719-0.35938-1.0781 0-0.44531 0.11328-0.80469 0.34375-1.0781 0.23828-0.28125 0.56641-0.42188 0.98438-0.42188 0.20703 0 0.40625 0.046875 0.59375 0.14062 0.19531 0.085937 0.36328 0.23438 0.5 0.45312 0.13281 0.21875 0.20312 0.55859 0.20312 1.0156zm-0.5-0.40625c-0.023438-0.28906-0.10938-0.5-0.26562-0.625s-0.33594-0.1875-0.53125-0.1875c-0.21875 0-0.40625 0.078125-0.5625 0.23438-0.14844 0.14844-0.23047 0.33984-0.25 0.57812zm-0.125-2.2969-0.59375 0.75h-0.39062l0.35938-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.125-3.9375-1.0781 3.9375h-0.5l-0.85938-3.1094c-0.042969-0.15625-0.070312-0.27344-0.078125-0.35938h-0.015625l-0.10938 0.46875-0.84375 3h-0.51562l-1.0625-3.9375h0.53125l0.60938 2.5781c0.082031 0.34375 0.13281 0.59375 0.15625 0.75v0.0625h0.015625c0.070312-0.34375 0.12891-0.58594 0.17188-0.73438l0.75-2.6562h0.625l0.5625 1.9844c0.14453 0.5 0.25 0.96875 0.3125 1.4062 0.039063-0.21875 0.10156-0.50391 0.1875-0.85938l0.625-2.5312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.9375 0v-0.4375h-1.9219l1.875-2.875v-0.046875h-2.5312v0.45312h1.7344l-1.875 2.8594v0.046875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5781-3.3906c-0.4375 0-0.8125 0.09375-1.0156 0.1875v0.48438h0.015625c0.17188-0.09375 0.5-0.23438 0.90625-0.23438 0.71875 0 0.9375 0.34375 0.9375 0.92188v0.3125c-0.20312-0.09375-0.5625-0.1875-0.9375-0.1875-0.79688 0-1.1719 0.40625-1.1719 0.98438 0 0.59375 0.42188 0.96875 1.0156 0.96875 0.57812 0 0.9375-0.28125 1.0938-0.46875v0.42188h0.53125v-2.0781c0-0.8125-0.40625-1.3125-1.375-1.3125zm0.84375 2.5938c-0.14062 0.21875-0.4375 0.45312-0.89062 0.45312-0.48438 0-0.6875-0.25-0.6875-0.59375 0-0.375 0.23438-0.64062 0.76562-0.64062 0.3125 0 0.60938 0.09375 0.8125 0.17188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2656-3.3594c-0.57812 0-0.9375 0.32812-1.1094 0.57812v-0.57812h-0.53125v3.3594h0.53125v-2.3594c0.17188-0.20312 0.51562-0.48438 0.95312-0.48438 0.078125 0 0.15625 0.015625 0.1875 0.015625h0.015625v-0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2969-3.3906c-0.54688 0-0.95312 0.29688-1.1406 0.54688v-2.0625h-0.53125v4.9062h0.53125v-2.4219c0.17188-0.25 0.53125-0.54688 0.95312-0.54688 0.45312 0 0.76562 0.25 0.76562 0.82812v2.1406h0.53125v-2.2656c0-0.75-0.48438-1.125-1.1094-1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375-3.4375c-0.92188 0-1.5938 0.6875-1.5938 1.7656 0 1.0625 0.67188 1.75 1.5938 1.75 0.90625 0 1.5938-0.6875 1.5938-1.75 0-1.0781-0.6875-1.7656-1.5938-1.7656zm0 3.0625c-0.60938 0-1.0469-0.5-1.0469-1.2969 0-0.8125 0.4375-1.2969 1.0469-1.2969s1.0469 0.48438 1.0469 1.2969c0 0.79688-0.4375 1.2969-1.0469 1.2969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4219-3.3906c-0.59375 0-0.98438 0.3125-1.1719 0.57812-0.17188-0.39062-0.54688-0.57812-0.96875-0.57812-0.5625 0-0.9375 0.29688-1.125 0.54688v-0.51562h-0.53125v3.3594h0.53125v-2.4062c0.14062-0.23438 0.45312-0.5625 0.89062-0.5625 0.42188 0 0.76562 0.23438 0.76562 0.8125v2.1562h0.53125v-2.4219c0.15625-0.26562 0.46875-0.54688 0.85938-0.54688 0.45312 0 0.78125 0.25 0.78125 0.8125v2.1562h0.53125v-2.3125c0-0.76562-0.53125-1.0781-1.0938-1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2344-1.8906c0-1.0781-0.67188-1.5469-1.375-1.5469-0.8125 0-1.5156 0.60938-1.5156 1.7656 0 1.0938 0.65625 1.7188 1.6406 1.7188 0.51562 0 0.90625-0.17188 1.1094-0.29688v-0.48438h-0.015625c-0.1875 0.15625-0.54688 0.32812-1.0625 0.32812-0.76562 0-1.125-0.46875-1.1406-1.1562h2.3438s0.015625-0.14062 0.015625-0.32812zm-2.3594-0.03125c0.03125-0.73438 0.4375-1.0938 0.98438-1.0938 0.5 0 0.85938 0.375 0.85938 1v0.09375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562 0.03125c0.1875 0 0.34375-0.14062 0.34375-0.34375s-0.15625-0.34375-0.34375-0.34375-0.34375 0.14062-0.34375 0.34375 0.15625 0.34375 0.34375 0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-10-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.34375-1.6719c0 1 0.64062 1.7188 1.6406 1.7188 0.42188 0 0.73438-0.125 0.875-0.21875v-0.51562h-0.015625c-0.15625 0.125-0.45312 0.26562-0.82812 0.26562-0.60938 0-1.125-0.39062-1.125-1.25s0.51562-1.25 1.125-1.25c0.375 0 0.67188 0.14062 0.82812 0.26562h0.015625v-0.51562c-0.14062-0.09375-0.45312-0.21875-0.875-0.21875-1 0-1.6406 0.70312-1.6406 1.7188z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ec008c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m326.23 269.54v-0.25h-325.73v-268.79h325.48v269.04h0.25v-0.25 0.25h0.25v-269.54h-326.48v269.79h326.48v-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.58 18.109h-0.25c0 1.5078-0.5 2.8711-1.3047 3.8477-0.80078 0.98047-1.8906 1.5703-3.0898 1.5703h-21.887c-1.1992 0-2.2891-0.58984-3.0938-1.5703-0.80079-0.97657-1.3047-2.3398-1.3047-3.8477 0-1.5117 0.5039-2.875 1.3047-3.8516 0.80468-0.97656 1.8945-1.5703 3.0938-1.5703h21.887c1.1992 0 2.2891 0.59375 3.0898 1.5703 0.80469 0.97656 1.3047 2.3398 1.3047 3.8516h0.5c0-1.6211-0.53516-3.0938-1.418-4.168-0.87891-1.0742-2.1094-1.7539-3.4766-1.7539h-21.887c-1.3672 0-2.6016 0.67968-3.4805 1.7539-0.87891 1.0742-1.418 2.5469-1.418 4.168s0.53906 3.0898 1.418 4.1641c0.8789 1.0781 2.1133 1.7539 3.4805 1.7539h21.887c1.3672 0 2.5977-0.67578 3.4766-1.7539 0.88281-1.0742 1.418-2.543 1.418-4.1641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.859 150.48v-0.25c-1.5117 0-2.875-0.5-3.8516-1.3008-0.97657-0.80469-1.5664-1.8984-1.5664-3.0938v-21.887c0-1.1992 0.58984-2.293 1.5664-3.0938 0.97656-0.80078 2.3398-1.3047 3.8516-1.3047 1.5078 0 2.8711 0.50391 3.8477 1.3047 0.98046 0.80078 1.5703 1.8945 1.5703 3.0938v21.887c0 1.1953-0.58985 2.2891-1.5703 3.0938-0.97657 0.80078-2.3398 1.3008-3.8477 1.3008v0.5c1.6211 0 3.0938-0.53516 4.168-1.418 1.0742-0.8789 1.75-2.1094 1.75-3.4766v-21.887c0-1.3711-0.67578-2.6016-1.75-3.4805-1.0742-0.8789-2.5469-1.418-4.168-1.418s-3.0938 0.53907-4.168 1.418c-1.0742 0.87891-1.7539 2.1094-1.75 3.4805v21.887c0 1.3672 0.67578 2.5977 1.75 3.4766 1.0742 0.88281 2.5469 1.418 4.168 1.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.12 150.48v-0.25c-1.5078 0-2.8711-0.5-3.8476-1.3008-0.98047-0.80469-1.5703-1.8984-1.5703-3.0938v-21.887c0-1.1992 0.58984-2.293 1.5703-3.0938 0.97656-0.80078 2.3398-1.3047 3.8476-1.3047 1.5117 0 2.875 0.50391 3.8516 1.3047 0.98047 0.80078 1.5703 1.8945 1.5703 3.0938v21.887c0 1.1953-0.58984 2.2891-1.5703 3.0938-0.97657 0.80078-2.3398 1.3008-3.8516 1.3008v0.5c1.6211 0 3.0938-0.53516 4.168-1.418 1.0742-0.8789 1.7539-2.1094 1.7539-3.4766v-21.887c0-1.3711-0.67969-2.6016-1.7539-3.4805-1.0742-0.8789-2.5469-1.418-4.168-1.418-1.6172 0-3.0898 0.53907-4.1641 1.418-1.0742 0.87891-1.7539 2.1094-1.7539 3.4805v21.887c0 1.3672 0.67968 2.5977 1.7539 3.4766 1.0742 0.88281 2.5469 1.418 4.1641 1.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.58 251.68h-0.25c0 1.5078-0.5 2.875-1.3047 3.8516-0.80078 0.97656-1.8906 1.5664-3.0898 1.5664h-21.887c-1.1992 0-2.2891-0.58985-3.0938-1.5664-0.80079-0.97656-1.3047-2.3438-1.3047-3.8516 0-1.5117 0.5039-2.875 1.3047-3.8516 0.80468-0.97657 1.8945-1.5664 3.0938-1.5664h21.887c1.1992 0 2.2891 0.58984 3.0898 1.5664 0.80469 0.97656 1.3047 2.3398 1.3047 3.8516h0.5c0-1.6211-0.53516-3.0938-1.418-4.168-0.87891-1.0742-2.1094-1.7539-3.4766-1.75h-21.887c-1.3672-4e-3 -2.6016 0.67578-3.4805 1.75-0.87891 1.0742-1.418 2.5469-1.418 4.168s0.53906 3.0938 1.418 4.168c0.8789 1.0742 2.1133 1.75 3.4805 1.75h21.887c1.3672 0 2.5977-0.67578 3.4766-1.75 0.88281-1.0742 1.418-2.5469 1.418-4.168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.1547e-5 135.14h12.191v-0.5h-12.191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.51 135.14h12.188v-0.5h-12.188z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m284.91 223.75v-0.30078h-104.58v-56.09h104.28v56.391h0.30078v-0.30078 0.30078h0.29688v-56.992h-105.48v57.293h105.48v-0.30078",
    fill: "#ea2628"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.449 174.74-0.46484-1.2422-0.45313 1.2422zm1.2422 1.3281h-0.73437l-0.28907-0.76172h-1.3438l-0.27734 0.76172h-0.71875l1.3008-3.3516h0.71875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.199 174.14h0.50391c0.32422 0 0.52734-0.0117 0.60547-0.0391l0.1914-0.14453c0.0469-0.0664 0.0664-0.14844 0.0664-0.25 0-0.11328-0.0273-0.20312-0.0898-0.27344-0.0586-0.0703-0.14063-0.11328-0.25391-0.13281-0.0547-8e-3 -0.21875-0.0117-0.49219-0.0117h-0.53125zm-0.67578 1.9336v-3.3516h1.4258c0.35547 0 0.61719 0.0312 0.78125 0.0898 0.16016 0.0586 0.29297 0.16797 0.39063 0.32422 0.0976 0.15234 0.14453 0.32812 0.14453 0.52734 0 0.25-0.0742 0.45703-0.21875 0.6211-0.14844 0.16406-0.36719 0.26953-0.66016 0.3125 0.14453 0.0859 0.26563 0.17578 0.35938 0.28125 0.0937 0.10156 0.22265 0.28125 0.38281 0.54296l0.41016 0.65235h-0.8125l-0.48438-0.73043c-0.17187-0.26172-0.29297-0.42188-0.35547-0.49219l-0.20703-0.13672c-0.0703-0.0273-0.18359-0.0391-0.33984-0.0391h-0.14063v1.3984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.129 176.07v-2.7852h-0.99219v-0.5664h2.6602v0.5664h-0.98828v2.7852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.824 175.43h0.64063v0.64063h-0.64063zm0-1.7891h0.64063v0.64453h-0.64063z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.609 178.45v0.47266h96.836v31.949h-96.367v-32.422h-0.46875v0.47266-0.47266h-0.47266v33.363h98.25v-33.832h-98.25v0.46875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.78 206.23v0.125h76.664v-22.926h-76.789v22.926h0.125v-0.125h0.125v-22.551h76.289v22.426h-76.414v0.125h0.125"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432.45 -267.16)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 458.06448,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.66495,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 490.81036,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 511.11996,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 515.26538,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.64771,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.79315,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 570.39362,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.539,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.99402,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.13947,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 627.59448,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.73993,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 666.96167,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 671.10712,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.00299,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.14844,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.85242,
    y: 327.535,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 463.44757,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 467.59299,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 496.186,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 500.33142,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 509.85992,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 514.00537,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 523.53387,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 527.67932,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.98889,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.13434,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.53711,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.6825,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.28296,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.42841,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 621.59259,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 625.73804,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 647.70282,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 651.84821,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 675.88574,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.03113,
    y: 335.33499,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27646,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 464.39267,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 485.47534,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 488.19208,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 517.91107,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.56671,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.15833,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.87506,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.28131,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.50696,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.45752,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.17426,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.38422,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.50043,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 653.3642,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 656.08093,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.79199,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.01764,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.28876,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.00549,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 742.30225,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.52789,
    y: 352.23999,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 458.98349,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 461.44803,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 497.67047,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 503.64447,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.09369,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.55865,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.52625,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.76862,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.23413,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.97705,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.43408,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.61523,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 638.08032,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 672.14081,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.60571,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.05566,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.52106,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.45605,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.42957,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.50244,
    y: 359.44,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.07809,
    y: 366.64001,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 452.64157,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.12402,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 469.32886,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.99557,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.62439,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.69031,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.72357,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 519.39056,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 529.88684,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 534.4436,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.71765,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.38483,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 588.62903,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.06909,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 634.7439,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.30048,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 671.13672,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 673.80347,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.49512,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.31946,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 748.50781,
    y: 366.64001,
    xlinkHref: "#glyph-2-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.16199,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.37222,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 496.58398,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.46332,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.34021,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.55316,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.76483,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.64014,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.51874,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.72961,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 649.60822,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 661.48505,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.69598,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.90533,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 744.12189,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.33344,
    y: 297.142,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 484.168,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 487.59799,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 525.36603,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.79358,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.43964,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.87091,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 634.30493,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 637.73535,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.49817,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.92902,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.69183,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.45471,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.88483,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 749.32764,
    y: 304.34201,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 441.16599,
    y: 311.54199,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 455.67395,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 470.21793,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 473.55396,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 495.88593,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 525.21991,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.55597,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.88794,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.22192,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.55792,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.89197,
    y: 311.54199,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 457.96597,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.96997,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 481.97797,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 485.20596,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504.87997,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 508.10797,
    y: 286.3959,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66699,
    y: 384.10999,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.66998,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.98102,
    y: 384.10999,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.59448,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.90552,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.9823,
    y: 384.10999,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.59583,
    y: 384.10999,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.51733,
    y: 384.10999,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 571.74133,
    y: 384.10999,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.05231,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.12964,
    y: 384.10999,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.44061,
    y: 384.10999,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.75165,
    y: 384.10999,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.06262,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.37366,
    y: 384.10999,
    xlinkHref: "#glyph-7-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.98712,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 596.29816,
    y: 384.10999,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.4696,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.54657,
    y: 384.10999,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.85754,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.02905,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.34003,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.51154,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.58997,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.901,
    y: 384.10999,
    xlinkHref: "#glyph-7-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.21198,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.38348,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.46112,
    y: 384.10999,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 621.07465,
    y: 384.10999,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 622.24615,
    y: 384.10999,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 625.55713,
    y: 384.10999,
    xlinkHref: "#glyph-7-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.17065,
    y: 384.10999,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.17365,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.48462,
    y: 384.10999,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.09814,
    y: 384.10999,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 640.26965,
    y: 384.10999,
    xlinkHref: "#glyph-7-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 644.19116,
    y: 384.10999,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 647.80463,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 648.97614,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 650.05316,
    y: 384.10999,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 653.36414,
    y: 384.10999,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 656.97766,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 658.14917,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 659.22626,
    y: 384.10999,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 660.39777,
    y: 384.10999,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 664.01129,
    y: 384.10999,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 667.62476,
    y: 384.10999,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 668.79626,
    y: 384.10999,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 671.79926,
    y: 384.10999,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 675.11029,
    y: 384.10999,
    xlinkHref: "#glyph-7-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.42126,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.59277,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.6698,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.98077,
    y: 384.10999,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.5943,
    y: 384.10999,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.59729,
    y: 384.10999,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.90826,
    y: 384.10999,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.07977,
    y: 384.10999,
    xlinkHref: "#glyph-7-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.39081,
    y: 384.10999,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.31232,
    y: 384.10999,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.48376,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.56134,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.87231,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.94965,
    y: 384.10999,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 712.56317,
    y: 384.10999,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.48468,
    y: 384.10999,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.09814,
    y: 384.10999,
    xlinkHref: "#glyph-7-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.71167,
    y: 384.10999,
    xlinkHref: "#glyph-7-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.32513,
    y: 384.10999,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.63617,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 731.80768,
    y: 384.10999,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66699,
    y: 389.10922,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.36853,
    y: 389.10922,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.62518,
    y: 389.10922,
    xlinkHref: "#glyph-8-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.88184,
    y: 389.10922,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.13849,
    y: 389.10922,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.22638,
    y: 389.10922,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.14923,
    y: 389.10922,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.54822,
    y: 389.10922,
    xlinkHref: "#glyph-8-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.11023,
    y: 389.10922,
    xlinkHref: "#glyph-8-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.89868,
    y: 389.10922,
    xlinkHref: "#glyph-8-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.68719,
    y: 389.10922,
    xlinkHref: "#glyph-8-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.47571,
    y: 389.10922,
    xlinkHref: "#glyph-8-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.26422,
    y: 389.10922,
    xlinkHref: "#glyph-8-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.05267,
    y: 389.10922,
    xlinkHref: "#glyph-8-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.84119,
    y: 389.10922,
    xlinkHref: "#glyph-8-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.62964,
    y: 389.10922,
    xlinkHref: "#glyph-8-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 588.07751,
    y: 389.36783,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.89313,
    y: 389.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.29211,
    y: 389.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.68842,
    y: 389.36783,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.38995,
    y: 389.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 602.64667,
    y: 389.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.65326,
    y: 389.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.02313,
    y: 389.36783,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.81165,
    y: 389.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 618.81848,
    y: 389.36783,
    xlinkHref: "#glyph-7-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 622.82507,
    y: 389.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.08173,
    y: 389.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 627.47778,
    y: 389.36783,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.56604,
    y: 389.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.82269,
    y: 389.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.52417,
    y: 389.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 640.591,
    y: 389.36783,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 643.37952,
    y: 389.36783,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 646.16803,
    y: 389.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 651.53827,
    y: 389.36783,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 654.6261,
    y: 389.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 658.02515,
    y: 389.36783,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 661.72662,
    y: 389.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 666.79486,
    y: 389.36783,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 670.49365,
    y: 389.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.50317,
    y: 389.36783,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.81244,
    y: 389.36783,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.88031,
    y: 389.36783,
    xlinkHref: "#glyph-7-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.27936,
    y: 389.36783,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.98083,
    y: 389.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.37982,
    y: 389.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.77606,
    y: 389.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.03265,
    y: 389.36783,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.47314,
    y: 389.36783,
    xlinkHref: "#glyph-8-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.23407,
    y: 389.36783,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.16003,
    y: 389.36783,
    xlinkHref: "#glyph-8-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.94733,
    y: 389.36783,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 714.87329,
    y: 389.36783,
    xlinkHref: "#glyph-8-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 717.66296,
    y: 389.36783,
    xlinkHref: "#glyph-8-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.68799,
    y: 389.36783,
    xlinkHref: "#glyph-8-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.38568,
    y: 389.36783,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.4538,
    y: 389.36783,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66693,
    y: 394.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.28046,
    y: 394.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.89398,
    y: 394.36783,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.20496,
    y: 394.36783,
    xlinkHref: "#glyph-7-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.59747,
    y: 394.36783,
    xlinkHref: "#glyph-7-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.76898,
    y: 394.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.46948,
    y: 394.36783,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.16998,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.34143,
    y: 394.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.04193,
    y: 394.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 571.74243,
    y: 394.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.44293,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.61444,
    y: 394.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.31494,
    y: 394.36783,
    xlinkHref: "#glyph-7-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.01544,
    y: 394.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.71594,
    y: 394.36783,
    xlinkHref: "#glyph-7-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 584.88745,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.58795,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.28845,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.98895,
    y: 394.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 595.68945,
    y: 394.36783,
    xlinkHref: "#glyph-7-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.16345,
    y: 394.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 599.86395,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 602.56445,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.81256,
    y: 394.36783,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.03656,
    y: 394.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.95807,
    y: 394.36783,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.57159,
    y: 394.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 618.88257,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.13062,
    y: 394.36783,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.74408,
    y: 394.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 627.66559,
    y: 394.36783,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.88959,
    y: 394.36783,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.20056,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 636.44818,
    y: 394.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.75922,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 640.93073,
    y: 394.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 644.2417,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 645.41321,
    y: 394.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 648.72418,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 649.89569,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 651.14282,
    y: 394.36783,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 654.45386,
    y: 394.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 655.62537,
    y: 394.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 659.23883,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 660.4859,
    y: 394.36783,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 663.1864,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 665.8869,
    y: 394.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 668.5874,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 669.75885,
    y: 394.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 672.45935,
    y: 394.36783,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 675.15985,
    y: 394.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.86035,
    y: 394.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.03186,
    y: 394.36783,
    xlinkHref: "#glyph-7-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.73236,
    y: 394.36783,
    xlinkHref: "#glyph-7-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.43286,
    y: 394.36783,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.13336,
    y: 394.36783,
    xlinkHref: "#glyph-7-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.27588,
    y: 394.36783,
    xlinkHref: "#glyph-7-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.4184,
    y: 394.36783,
    xlinkHref: "#glyph-7-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.56085,
    y: 394.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.73236,
    y: 394.36783,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 706.73535,
    y: 394.36783,
    xlinkHref: "#glyph-7-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.04639,
    y: 394.36783,
    xlinkHref: "#glyph-7-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.1889,
    y: 394.36783,
    xlinkHref: "#glyph-7-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.33136,
    y: 394.36783,
    xlinkHref: "#glyph-7-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.47388,
    y: 394.36783,
    xlinkHref: "#glyph-7-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.61639,
    y: 394.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66693,
    y: 399.36783,
    xlinkHref: "#glyph-7-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.14093,
    y: 399.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.84143,
    y: 399.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.54193,
    y: 399.36783,
    xlinkHref: "#glyph-7-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.24243,
    y: 399.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.94293,
    y: 399.36783,
    xlinkHref: "#glyph-7-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.41693,
    y: 399.36783,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.11743,
    y: 399.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.81793,
    y: 399.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.51843,
    y: 399.36783,
    xlinkHref: "#glyph-7-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.99243,
    y: 399.36783,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 571.69293,
    y: 399.36783,
    xlinkHref: "#glyph-7-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.39343,
    y: 399.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 577.09393,
    y: 399.36783,
    xlinkHref: "#glyph-7-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.56793,
    y: 399.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.73944,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.41821,
    y: 399.36783,
    xlinkHref: "#glyph-7-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 584.11871,
    y: 399.36783,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.73218,
    y: 399.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.3457,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.0249,
    y: 399.36783,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 595.7254,
    y: 399.36783,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.4259,
    y: 399.36783,
    xlinkHref: "#glyph-7-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.1264,
    y: 399.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.8269,
    y: 399.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.5274,
    y: 399.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.22791,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 610.90704,
    y: 399.36783,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.91003,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.22101,
    y: 399.36783,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.83453,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.14551,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 625.82428,
    y: 399.36783,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.43781,
    y: 399.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.35931,
    y: 399.36783,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 637.58331,
    y: 399.36783,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 640.89429,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 642.57355,
    y: 399.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 646.18707,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 649.49805,
    y: 399.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 653.11157,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 656.42255,
    y: 399.36783,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 660.03607,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 663.34705,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 665.02563,
    y: 399.36783,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 666.19714,
    y: 399.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 669.81061,
    y: 399.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 673.42413,
    y: 399.36783,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.59564,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.27417,
    y: 399.36783,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 679.8877,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.19867,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.87732,
    y: 399.36783,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.57782,
    y: 399.36783,
    xlinkHref: "#glyph-7-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.27832,
    y: 399.36783,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.97882,
    y: 399.36783,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.67932,
    y: 399.36783,
    xlinkHref: "#glyph-7-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.37982,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.73798,
    y: 399.36783,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.96198,
    y: 399.36783,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.88348,
    y: 399.36783,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.49701,
    y: 399.36783,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.5,
    y: 399.36783,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.11346,
    y: 399.36783,
    xlinkHref: "#glyph-7-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.4245,
    y: 399.36783,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.73547,
    y: 399.36783,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.43597,
    y: 399.36783,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.60748,
    y: 399.36783,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66693,
    y: 404.36703,
    xlinkHref: "#glyph-7-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.58844,
    y: 404.36703,
    xlinkHref: "#glyph-7-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.20197,
    y: 404.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.51294,
    y: 404.36703,
    xlinkHref: "#glyph-7-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.82397,
    y: 404.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.13495,
    y: 404.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.74847,
    y: 404.36703,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.91998,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.30383,
    y: 404.36703,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.9173,
    y: 404.36703,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.6178,
    y: 404.36703,
    xlinkHref: "#glyph-7-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.92883,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.31287,
    y: 404.36703,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.01337,
    y: 404.36703,
    xlinkHref: "#glyph-7-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.93488,
    y: 404.36703,
    xlinkHref: "#glyph-7-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.63538,
    y: 404.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.80688,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.18951,
    y: 404.36703,
    xlinkHref: "#glyph-7-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.33197,
    y: 404.36703,
    xlinkHref: "#glyph-7-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 602.47449,
    y: 404.36703,
    xlinkHref: "#glyph-7-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.617,
    y: 404.36703,
    xlinkHref: "#glyph-7-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.75952,
    y: 404.36703,
    xlinkHref: "#glyph-7-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.90198,
    y: 404.36703,
    xlinkHref: "#glyph-7-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.04449,
    y: 404.36703,
    xlinkHref: "#glyph-7-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.18701,
    y: 404.36703,
    xlinkHref: "#glyph-7-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.32947,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 634.71234,
    y: 404.36703,
    xlinkHref: "#glyph-7-57"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.8548,
    y: 404.36703,
    xlinkHref: "#glyph-7-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 644.99731,
    y: 404.36703,
    xlinkHref: "#glyph-7-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 650.13983,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 651.52332,
    y: 404.36703,
    xlinkHref: "#glyph-7-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 656.66583,
    y: 404.36703,
    xlinkHref: "#glyph-7-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 661.80835,
    y: 404.36703,
    xlinkHref: "#glyph-7-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 666.95081,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 668.33356,
    y: 404.36703,
    xlinkHref: "#glyph-7-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 673.47607,
    y: 404.36703,
    xlinkHref: "#glyph-7-64"
  }), /*#__PURE__*/React.createElement("use", {
    x: 678.61859,
    y: 404.36703,
    xlinkHref: "#glyph-7-65"
  }), /*#__PURE__*/React.createElement("use", {
    x: 683.76105,
    y: 404.36703,
    xlinkHref: "#glyph-7-66"
  }), /*#__PURE__*/React.createElement("use", {
    x: 688.90356,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.28754,
    y: 404.36703,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 692.98804,
    y: 404.36703,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 695.68854,
    y: 404.36703,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 698.38904,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.77197,
    y: 404.36703,
    xlinkHref: "#glyph-7-67"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.91449,
    y: 404.36703,
    xlinkHref: "#glyph-7-68"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.05701,
    y: 404.36703,
    xlinkHref: "#glyph-7-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.19946,
    y: 404.36703,
    xlinkHref: "#glyph-7-69"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.34198,
    y: 404.36703,
    xlinkHref: "#glyph-7-70"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.4845,
    y: 404.36703,
    xlinkHref: "#glyph-7-71"
  }), /*#__PURE__*/React.createElement("use", {
    x: 730.62701,
    y: 404.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66693,
    y: 409.36703,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.36743,
    y: 409.36703,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.06793,
    y: 409.36703,
    xlinkHref: "#glyph-7-72"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.21045,
    y: 409.36703,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.47211,
    y: 409.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.17261,
    y: 409.36703,
    xlinkHref: "#glyph-7-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.87311,
    y: 409.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.57361,
    y: 409.36703,
    xlinkHref: "#glyph-7-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.04761,
    y: 409.36703,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.74811,
    y: 409.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.44861,
    y: 409.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.14911,
    y: 409.36703,
    xlinkHref: "#glyph-7-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.62311,
    y: 409.36703,
    xlinkHref: "#glyph-7-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.32361,
    y: 409.36703,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.02411,
    y: 409.36703,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 584.72461,
    y: 409.36703,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.42517,
    y: 409.36703,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.85834,
    y: 409.36703,
    xlinkHref: "#glyph-8-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.4718,
    y: 409.36703,
    xlinkHref: "#glyph-8-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.08539,
    y: 409.36703,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.96069,
    y: 409.36703,
    xlinkHref: "#glyph-8-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 604.66119,
    y: 409.36703,
    xlinkHref: "#glyph-8-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.36163,
    y: 409.36703,
    xlinkHref: "#glyph-8-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 610.06219,
    y: 409.36703,
    xlinkHref: "#glyph-8-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.7627,
    y: 409.36703,
    xlinkHref: "#glyph-8-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.46313,
    y: 409.36703,
    xlinkHref: "#glyph-8-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 618.16364,
    y: 409.36703,
    xlinkHref: "#glyph-8-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.86414,
    y: 409.36703,
    xlinkHref: "#glyph-8-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.56464,
    y: 409.36703,
    xlinkHref: "#glyph-8-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 625.03864,
    y: 409.36703,
    xlinkHref: "#glyph-8-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 627.73914,
    y: 409.36703,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.17236,
    y: 409.36703,
    xlinkHref: "#glyph-8-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 634.39368,
    y: 409.36703,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 637.70734,
    y: 409.36703,
    xlinkHref: "#glyph-8-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.18134,
    y: 409.36703,
    xlinkHref: "#glyph-8-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 643.40265,
    y: 409.36703,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 646.71631,
    y: 409.36703,
    xlinkHref: "#glyph-8-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 650.3299,
    y: 409.36703,
    xlinkHref: "#glyph-8-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 654.25134,
    y: 409.36703,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 659.12701,
    y: 409.36703,
    xlinkHref: "#glyph-8-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 661.56061,
    y: 409.36703,
    xlinkHref: "#glyph-8-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 664.87158,
    y: 409.36703,
    xlinkHref: "#glyph-8-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 666.04309,
    y: 409.36703,
    xlinkHref: "#glyph-8-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 670.00513,
    y: 409.36703,
    xlinkHref: "#glyph-8-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 673.61859,
    y: 409.36703,
    xlinkHref: "#glyph-8-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.62164,
    y: 409.36703,
    xlinkHref: "#glyph-8-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 682.71802,
    y: 409.36703,
    xlinkHref: "#glyph-8-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.93933,
    y: 409.36703,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.25299,
    y: 409.36703,
    xlinkHref: "#glyph-8-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.86652,
    y: 409.36703,
    xlinkHref: "#glyph-8-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 697.78802,
    y: 409.36703,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 702.66333,
    y: 409.36703,
    xlinkHref: "#glyph-8-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 703.83478,
    y: 409.36703,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 708.09961,
    y: 409.36703,
    xlinkHref: "#glyph-8-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 710.53284,
    y: 409.36703,
    xlinkHref: "#glyph-8-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 713.23328,
    y: 409.36703,
    xlinkHref: "#glyph-8-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.93378,
    y: 409.36703,
    xlinkHref: "#glyph-8-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 718.63416,
    y: 409.36703,
    xlinkHref: "#glyph-8-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 721.33466,
    y: 409.36703,
    xlinkHref: "#glyph-8-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 724.0351,
    y: 409.36703,
    xlinkHref: "#glyph-8-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 726.7356,
    y: 409.36703,
    xlinkHref: "#glyph-8-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 729.43616,
    y: 409.36703,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66614,
    y: 414.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.88715,
    y: 414.36703,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.16064,
    y: 414.36703,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 554.52118,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.49219,
    y: 414.36703,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.15515,
    y: 414.36703,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.20764,
    y: 414.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.56818,
    y: 414.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.23114,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 577.90839,
    y: 414.36703,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.26886,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 585.23987,
    y: 414.36703,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.61151,
    y: 414.36703,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.664,
    y: 414.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.02454,
    y: 414.36703,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.6875,
    y: 414.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.75525,
    y: 414.36703,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.41821,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.38922,
    y: 414.36703,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.66272,
    y: 414.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 622.72943,
    y: 414.36703,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 627.00293,
    y: 414.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.36346,
    y: 414.36703,
    xlinkHref: "#glyph-7-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.72394,
    y: 414.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 634.94495,
    y: 414.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 638.60797,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 642.57892,
    y: 414.36703,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 645.5072,
    y: 414.36703,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 648.86768,
    y: 414.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 650.08868,
    y: 414.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 653.44916,
    y: 414.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 656.37671,
    y: 414.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 660.03973,
    y: 414.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 665.10681,
    y: 414.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 668.76984,
    y: 414.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 669.99084,
    y: 414.36703,
    xlinkHref: "#glyph-7-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 673.35132,
    y: 414.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.57233,
    y: 414.36703,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 677.9328,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 681.90381,
    y: 414.36703,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 685.56683,
    y: 414.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.78784,
    y: 414.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.14832,
    y: 414.36703,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 693.81134,
    y: 414.36703,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.86383,
    y: 414.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.93182,
    y: 414.36703,
    xlinkHref: "#glyph-7-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.68182,
    y: 414.36703,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.43182,
    y: 414.36703,
    xlinkHref: "#glyph-7-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.88885,
    y: 414.36703,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.55188,
    y: 414.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 719.52289,
    y: 414.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 722.44946,
    y: 414.36703,
    xlinkHref: "#glyph-7-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 725.19946,
    y: 414.36703,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.94946,
    y: 414.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66614,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.23566,
    y: 419.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.11029,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.76678,
    y: 419.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.64154,
    y: 419.36703,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.21106,
    y: 419.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.33856,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.58606,
    y: 419.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.71356,
    y: 419.36703,
    xlinkHref: "#glyph-7-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.28308,
    y: 419.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.8526,
    y: 419.36703,
    xlinkHref: "#glyph-7-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.42206,
    y: 419.36703,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.68909,
    y: 419.36703,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.64545,
    y: 419.36703,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.2149,
    y: 419.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.33954,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.60657,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.24426,
    y: 419.36703,
    xlinkHref: "#glyph-7-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.51129,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 604.77551,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.43201,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 610.0885,
    y: 419.36703,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.35291,
    y: 419.36703,
    xlinkHref: "#glyph-7-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.70142,
    y: 419.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.5592,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.82324,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.47974,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.04926,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.31622,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.97278,
    y: 419.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 639.54224,
    y: 419.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 640.66699,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 644.91431,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 648.18127,
    y: 419.36703,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 651.13776,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 654.70728,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 657.97424,
    y: 419.36703,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 661.24127,
    y: 419.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 665.11591,
    y: 419.36703,
    xlinkHref: "#glyph-7-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 668.07214,
    y: 419.36703,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 671.02838,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 674.29248,
    y: 419.36703,
    xlinkHref: "#glyph-7-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 676.94897,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 680.51849,
    y: 419.36703,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 684.39325,
    y: 419.36703,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 686.5011,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 690.07056,
    y: 419.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 691.19806,
    y: 419.36703,
    xlinkHref: "#glyph-7-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 694.4624,
    y: 419.36703,
    xlinkHref: "#glyph-7-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 696.57025,
    y: 419.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 699.22675,
    y: 419.36703,
    xlinkHref: "#glyph-7-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.88324,
    y: 419.36703,
    xlinkHref: "#glyph-7-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 704.53973,
    y: 419.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 707.19623,
    y: 419.36703,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 709.85272,
    y: 419.36703,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 711.96045,
    y: 419.36703,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 715.52997,
    y: 419.36703,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 716.6546,
    y: 419.36703,
    xlinkHref: "#glyph-7-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 720.22406,
    y: 419.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 723.79358,
    y: 419.36703,
    xlinkHref: "#glyph-7-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 727.05768,
    y: 419.36703,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.66614,
    y: 424.36624,
    xlinkHref: "#glyph-7-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 549.27966,
    y: 424.36624,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.59064,
    y: 424.36624,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.76215,
    y: 424.36624,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.98615,
    y: 424.36624,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.29718,
    y: 424.36624,
    xlinkHref: "#glyph-7-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.60815,
    y: 424.36624,
    xlinkHref: "#glyph-7-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.77966,
    y: 424.36624,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.39319,
    y: 424.36624,
    xlinkHref: "#glyph-7-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.31464,
    y: 424.36624,
    xlinkHref: "#glyph-7-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.48615,
    y: 424.36624,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.65765,
    y: 424.36624,
    xlinkHref: "#glyph-7-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.27118,
    y: 424.36624,
    xlinkHref: "#glyph-7-74"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.27417,
    y: 424.36624,
    xlinkHref: "#glyph-7-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 585.88763,
    y: 424.36624,
    xlinkHref: "#glyph-7-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.05914,
    y: 424.36624,
    xlinkHref: "#glyph-7-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.06213,
    y: 424.36624,
    xlinkHref: "#glyph-7-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.67566,
    y: 424.36624,
    xlinkHref: "#glyph-7-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.89966,
    y: 424.36624,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.60016,
    y: 424.36624,
    xlinkHref: "#glyph-7-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.30066,
    y: 424.36624,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.00116,
    y: 424.36624,
    xlinkHref: "#glyph-7-73"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.70166,
    y: 424.36624,
    xlinkHref: "#glyph-7-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.40216,
    y: 424.36624,
    xlinkHref: "#glyph-7-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.10266,
    y: 424.36624,
    xlinkHref: "#glyph-7-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.41364,
    y: 424.36624,
    xlinkHref: "#glyph-7-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.72467,
    y: 424.36624,
    xlinkHref: "#glyph-7-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.42517,
    y: 424.36624,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.59668,
    y: 424.36624,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 625.76819,
    y: 424.36624,
    xlinkHref: "#glyph-7-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 687.76001,
    y: 285.36301,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 701.54401,
    y: 285.36301,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 705.992,
    y: 285.36301,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 737.12799,
    y: 285.36301,
    xlinkHref: "#glyph-9-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.31152,
    y: 507.32599,
    xlinkHref: "#glyph-10-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.49652,
    y: 507.32599,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.02448,
    y: 507.32599,
    xlinkHref: "#glyph-10-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.45349,
    y: 507.32599,
    xlinkHref: "#glyph-10-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 585.98151,
    y: 507.32599,
    xlinkHref: "#glyph-10-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.9715,
    y: 507.32599,
    xlinkHref: "#glyph-10-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.84253,
    y: 507.32599,
    xlinkHref: "#glyph-10-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 599.94647,
    y: 507.32599,
    xlinkHref: "#glyph-10-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.36932,
    y: 507.32599,
    xlinkHref: "#glyph-10-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 604.90234,
    y: 507.32599,
    xlinkHref: "#glyph-10-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.98218,
    y: 507.32599,
    xlinkHref: "#glyph-10-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.85321,
    y: 507.32599,
    xlinkHref: "#glyph-10-5"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m251.89 247.86h-1.8477v5.625h1.8477zm1.9102-1.918v16.98h-1.8633v-7.5078h-1.9102v7.5156h-1.8945v-16.988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.25 245.95v1.8711h-1.8672v5.6719h1.8359v1.8945h-1.8398v5.6758h1.8438v1.8945h-3.7539v-17.008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.48 262.95h-3.7812v-17.008h3.7812v1.8867h-1.8711v13.23h1.8711"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m35.922 256.85 1.4922-1.4375 0.0195 0.72656 1.2852-8e-3 1.2812-0.0117 0.22657-0.0742c0.12109-0.043 0.28515-0.12109 0.35937-0.17578 0.46485-0.32422 0.57813-0.91797 0.28906-1.543-0.0391-0.0898-0.46875-0.84375-0.94921-1.6797-0.48438-0.83203-0.8711-1.5234-0.85938-1.5312l1.1445-0.64453c8e-3 8e-3 0.39844 0.6875 0.875 1.5078 0.96485 1.6719 1.0469 1.8242 1.1758 2.207 0.5 1.4883-0.10156 2.7031-1.5312 3.1172-0.4375 0.125-0.48437 0.12891-1.9141 0.14453l-1.3711 0.0156-0.0274 0.83203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.957 257.4c-0.9336-0.16406-1.6133-0.60937-1.9297-1.2695-0.13672-0.28125-0.17969-0.47265-0.19531-0.85156-0.0195-0.39063 0.0234-0.66406 0.16796-1.0898 0.11719-0.35938 0.26172-0.64063 0.82813-1.6172 0.26172-0.44531 0.47266-0.81641 0.46484-0.82031l-0.61718-0.38282 1.9883-0.5625 0.48828 1.9961-0.71094-0.32032c-0.082 0.10938-1.0117 1.7344-1.0742 1.875-0.10547 0.23829-0.15234 0.48047-0.13672 0.71094 0.0274 0.48828 0.29297 0.8086 0.82032 0.98828l0.20703 0.0703 3.8047 0.0156v1.3125l-1.9141-4e-3c-1.7148 0-1.9492-8e-3 -2.1914-0.0508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.637 249.51c-0.0234-0.0273 1.625-2.8906 1.8438-3.207 0.23828-0.35156 0.60547-0.72656 0.90625-0.93359 0.17969-0.125 0.53907-0.28516 0.76953-0.34375 0.57813-0.14453 1.2539 8e-3 1.793 0.40625 0.26953 0.19531 0.66016 0.61719 0.86328 0.92578 0.0937 0.14453 0.39844 0.65234 0.67188 1.125 0.26562 0.47266 0.49609 0.86328 0.5 0.86719l0.64062-0.33985-0.5039 1.9961-1.9766-0.5625 0.66406-0.42578c0-0.0391-1.0195-1.793-1.1445-1.9688-0.31641-0.44922-0.78907-0.6836-1.2031-0.60157-0.32812 0.0664-0.64844 0.28907-0.86719 0.60938-0.0625 0.082-0.48828 0.80859-0.95703 1.6133-0.46484 0.80469-0.85937 1.4688-0.875 1.4727-0.3789-0.19532-0.76562-0.40235-1.125-0.63282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.293 253.64v0.62109h-2.3984v-0.46875l0.85156-0.91796c0.58203-0.63672 0.68359-0.80079 0.68359-1.0977 0-0.30469-0.20703-0.49609-0.60156-0.49609-0.41406 0-0.70703 0.16015-0.84766 0.29687h-0.0117v-0.74609c0.16797-0.10547 0.5-0.23438 0.96094-0.23438 0.79688 0 1.2891 0.46094 1.2891 1.1172 0 0.51172-0.21093 0.85937-0.84765 1.4961l-0.42969 0.42969h1.3203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.098 253.64v0.62109h-2.3984v-0.46875l0.84766-0.91796c0.58594-0.63672 0.68359-0.80079 0.68359-1.0977 0-0.30469-0.20703-0.49609-0.59765-0.49609-0.41797 0-0.70703 0.16015-0.85157 0.29687h-0.0117v-0.74609c0.16796-0.10547 0.5039-0.23438 0.96484-0.23438 0.79687 0 1.2891 0.46094 1.2891 1.1172 0 0.51172-0.21094 0.85937-0.84765 1.4961l-0.4336 0.42969h1.3242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.641 261.13c0.0625 0.0156 0.14453 0.0195 0.25 0.0195 0.38281 0 0.61719-0.1875 0.61719-0.51172 0-0.3125-0.21875-0.47656-0.57032-0.47656-0.14453 0-0.24218 0.0117-0.29687 0.0234zm-0.50781-1.3008c0.18359-0.0352 0.4375-0.0586 0.78125-0.0586 0.375 0 0.64843 0.0781 0.82812 0.22656 0.16797 0.13672 0.27344 0.35547 0.27344 0.61719 0 0.26562-0.082 0.48828-0.23828 0.63672-0.20703 0.20312-0.52735 0.29687-0.88672 0.29687-0.0977 0-0.18359-4e-3 -0.25-0.0156v1.0547h-0.50781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.723 261.41-0.22266-0.6875c-0.0508-0.16797-0.0976-0.35938-0.14062-0.52344h-8e-3c-0.0391 0.16406-0.082 0.35937-0.13282 0.52344l-0.21484 0.6875zm-0.80469 0.38671-0.23828 0.79297h-0.52734l0.89844-2.7969h0.64843l0.91407 2.7969h-0.55079l-0.2539-0.79297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.707 261.13c0.0625 0.0156 0.14453 0.0195 0.24609 0.0195 0.38281 0 0.61719-0.1875 0.61719-0.51172 0-0.3125-0.21485-0.47656-0.57032-0.47656-0.14062 0-0.23828 0.0117-0.29296 0.0234zm-0.50782-1.3008c0.1836-0.0352 0.4375-0.0586 0.78125-0.0586 0.375 0 0.64844 0.0781 0.82813 0.22656 0.16406 0.13672 0.27344 0.35547 0.27344 0.61719 0 0.26562-0.082 0.48828-0.24219 0.63672-0.20313 0.20312-0.52344 0.29687-0.88672 0.29687-0.0937 0-0.17969-4e-3 -0.24609-0.0156v1.0547h-0.50782"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.55 262.64h-29.648c-3.543 0-6.4102-2.832-6.4102-6.3008v-10.68h29.648c3.5391 0 6.4102 2.832 6.4102 6.3008zm-6.4102-17.68h-30.359v11.367c0 3.8711 3.1914 7.0117 7.1211 7.0117h30.359v-11.371c0-3.8672-3.1914-7.0078-7.1211-7.0078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.281 242.14h-0.24218v0.98047h0.25c0.1914 0 0.30078-0.12891 0.30078-0.5 0-0.32031-0.0977-0.49219-0.3086-0.49219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.602 244.96-0.35157-1.3398h-0.21875v1.3398h-0.67187v-3.3828h0.97266c0.57031 0 0.91015 0.3125 0.91015 1 0 0.49219-0.16015 0.76172-0.39062 0.89063l0.4375 1.4922zm-1.5625-2.8203h-0.95703v0.80859h0.75781v0.57032h-0.75781v1.4297h-0.66016v-3.3789h1.6172zm2.4023-1.2695h-4.2422c-0.77734 0-1.4102 0.64062-1.4102 1.4102v3.3789h7.0703v-3.3789c0-0.78125-0.63672-1.4102-1.418-1.4102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.91 249.38c0 0.11328-0.0273 0.22266-0.0781 0.32031l-0.0899 0.10157c-0.10156 0.0586-0.21094 0.0976-0.32031 0.0976h-8.9609c-0.10937 0-0.23047-0.0273-0.32031-0.0976l-0.10156-0.10157c-0.0469-0.0977-0.0781-0.20703-0.0781-0.32031v-0.80078c0-0.34766 0.26953-0.62891 0.60156-0.62891h0.51954l0.70703-0.62109c0.15234-0.12891 0.38281-0.20703 0.62109-0.20703h5.0391c0.24219 0 0.47266 0.0781 0.6211 0.20703l0.71093 0.62109h0.51954c0.33203 0 0.60156 0.28125 0.60156 0.62891v0.80078zm-5.3906 2.2891c-0.11719-0.11718-0.11719-0.30859 0-0.41796 0.12109-0.1211 0.3125-0.1211 0.42187 0l0.94141 0.9414c0.11718 0.11719 0.11718 0.3086 0 0.41797l-0.94141 0.94141-0.21094 0.0898-0.21093-0.0898c-0.11719-0.1211-0.11719-0.3086 0-0.42188l0.42968-0.42969h-0.0195c-1.1406 0-2.0703 0.92969-2.0703 2.0703 0 1.1406 0.92969 2.0703 2.0703 2.0703 1.1406 0 2.0703-0.92969 2.0703-2.0703 0-0.26953-0.0508-0.53907-0.16015-0.78907-0.0586-0.15234 0-0.33203 0.16015-0.39062 0.15235-0.0586 0.33204 0 0.39063 0.16016 0.12891 0.32812 0.19922 0.66796 0.19922 1.0195 0 1.4726-1.1992 2.6719-2.668 2.6719-1.4727 0-2.6719-1.1992-2.6719-2.6719 0-1.4688 1.1992-2.668 2.6719-2.668h0.0273zm5 9.0625c0 0.28907-0.23829 0.53125-0.52735 0.53125h-0.45312c-0.21875 0-0.40625-0.13281-0.48828-0.32031-0.16016 0.19922-0.41016 0.32031-0.69141 0.32031h-4.8984c-0.28125 0-0.53125-0.13281-0.6914-0.32031-0.0781 0.1875-0.26954 0.32031-0.48829 0.32031h-0.44921c-0.29297 0-0.53125-0.24218-0.53125-0.53125v-1.9023c0-0.28906 0.23828-0.52734 0.53125-0.52734h0.44921l0.10938 8e-3c-0.21094-2.3398-0.53125-5.957-0.69141-7.5898-0.0195-0.16797 0.11328-0.32032 0.27344-0.32813 0.16797-0.0195 0.31641 0.10938 0.32813 0.26953 0.23828 2.5078 0.8789 9.6914 0.89062 9.7695 8e-3 0.1211 0.12891 0.21875 0.26953 0.21875h4.8984c0.14062 0 0.26172-0.0976 0.27344-0.21875 0-0.0703 0.63672-7.25 0.88672-9.7695 0.0195-0.16797 0.16015-0.28906 0.33203-0.26953 0.16797 0.0195 0.28906 0.16016 0.26953 0.32813-0.16016 1.6406-0.48047 5.25-0.69141 7.5898l0.10938-8e-3h0.45312c0.28906 0 0.52735 0.23828 0.52735 0.52734zm-2.3789-15.77h-14.41l4.9688 8.4375-4.8672 9.9414h21.43v-11.371c0-3.8672-3.1914-7.0078-7.1211-7.0078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.441 248.49h-5.0391c-0.14063 0-0.25-0.11328-0.25-0.25 0-0.14062 0.10937-0.25 0.25-0.25h5.0391c0.14063 0 0.25 0.10938 0.25 0.25 0 0.13672-0.10937 0.25-0.25 0.25m1.2305 0.0469-0.19922-0.0703-0.80078-0.69922s-0.12109-0.0586-0.23047-0.0586h-5.0391c-0.11328 0-0.20313 0.0312-0.23047 0.0586l-0.80078 0.69922-0.19922 0.0703h-0.63281l-8e-3 0.0391v0.73047h8.7812v-0.76953h-0.63281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.461 253.97c-0.76172 1.1211-0.10937 2.5898 0.67188 3.332 0.70703 0.67968 1.2891 0.83984 1.3594 0.85937l0.35938-0.69922 1.0508 2.8789-2.9805 0.60156 0.39844-0.73047-0.39844-0.23047c-1.25-0.82031-1.5195-1.9219-1.6016-2.2695-0.14844-0.60156-0.3711-2.3828 1.1406-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.441 254.02c0.53906 1.2422 2.1289 1.4805 3.1797 1.2109 0.92969-0.23828 1.3711-0.62109 1.4492-0.6914l-0.39844-0.69922 2.9883 0.65234-1.0781 2.8359-0.40235-0.70703-0.39062 0.20703c-1.3594 0.62109-2.4375 0.26172-2.7774 0.14063-0.58203-0.1875-2.2109-0.94922-2.5625-2.957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.73 251.03c-0.21093 1.4805-1.0976 2.1875-1.3789 2.418-0.48047 0.39063-2 1.3516-3.8711 0.5625 1.3398 0.20704 2.3906-0.99218 2.7422-2.0195 0.30859-0.92187 0.21875-1.5 0.19922-1.5938l-0.78906-0.0391 2.1562-2.168 1.8125 2.4375-0.82032-0.0508-0.0312 0.45313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.652 249.78c-0.67969 0-1.2422-0.55079-1.2422-1.2422 0-0.6875 0.55078-1.2383 1.2422-1.2383 0.6875 0 1.2383 0.55078 1.2383 1.2383 0 0.6914-0.55078 1.2422-1.2383 1.2422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.352 244.96c-4.4609 0-8.1016 3.6289-8.1016 8.0977 0 4.4609 3.6328 8.1016 8.1016 8.1016 0.23828 0 0.46875-0.0117 0.71093-0.0391l0.0469 0.80859 1.4805-1.4297-1.6602-1.2578 0.0625 0.84766c-0.21094 0.0195-0.42969 0.0312-0.65234 0.0312-0.33985 0-0.67969-0.0312-1.0078-0.0703l-0.0312-0.22266-0.76954-6.5586c-0.10937-1.2383 0.60157-1.4297 1.0391-1.25l2.4492 0.99218c0.28125 0.11719 0.42187-0.11328 0.42187-0.11328s0.16016-0.25-0.12109-0.42968c0 0-3.3477-2.2188-4.0586-2.3477-0.97265-0.17969-1.9297 0.60937-2.1523 1.6289l-1.1875 5.8203c-1.0195-1.2305-1.6406-2.8008-1.6406-4.5195 0-3.9024 3.168-7.0586 7.0586-7.0586 2.082 0 3.9492 0.89844 5.25 2.3359l0.73047-0.73828c-1.4805-1.6211-3.6094-2.6406-5.9688-2.6406m-3.6094 10.84c0.10938-0.28906 0.25781-0.26953 0.25781-0.26953s0.14063-0.0274 0.22266 0.26172l1.1601 4.0587c-0.96094-0.28125-1.8438-0.76172-2.5938-1.3906"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#171717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.633 250.37c-0.0234 0.34766-0.0703 0.91797-0.0937 1.1797-0.22657 2.418-0.73828 4.5273-1.5 6.2578-0.31641 0.72266-0.71875 1.4219-1.0664 1.8828l-6.5234-1.4023c0.10157-0.12891 0.19141-0.25781 0.26172-0.3711 1.2695-1.9062 2.0703-4.457 2.3086-7.3672 0.0312-0.41016 0.0625-1.0898 0.0625-1.5898l6.5586 1.3984zm0.46875-0.66016-7.332-1.5625c-0.10938-0.0273-0.23047 0-0.32032 0.082-0.0898 0.0703-0.13672 0.1875-0.1289 0.30079v0.0703c0.0195 0.34765 0 1.3594-0.0508 1.8906-0.23047 2.7891-0.98829 5.2188-2.1875 7.0274-0.14063 0.21093-0.35157 0.5-0.47266 0.64843l-0.10938 0.14063c-0.0781 0.10156-0.0976 0.24219-0.0586 0.35156 0.0391 0.1211 0.14063 0.21094 0.26953 0.23828l7.3203 1.5703h0.0781c0.11328 0 0.22266-0.0508 0.29297-0.14063l0.0976-0.11719c0.41016-0.51172 0.85938-1.3008 1.2227-2.1094 0.79688-1.8125 1.3281-3.9922 1.5586-6.4922 0.0312-0.32812 0.0898-1.1484 0.10157-1.4102v-0.12109c8e-3 -0.17969-0.11328-0.33594-0.29297-0.37891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.121 250.33v0.043l0.16797 0.0703c0.0625 0.0703 0.0937 0.16797 0.0937 0.27735-0.0117 0.19921-0.16016 0.37109-0.33203 0.37109l-0.16797-0.0703c-0.0625-0.0703-0.0937-0.16797-0.0937-0.27735 0.0117-0.20312 0.16015-0.37109 0.32031-0.37109v-0.043zm0.32031-0.0195c-0.082-0.0898-0.19922-0.14063-0.32031-0.14063-0.26953 0-0.5 0.26172-0.51953 0.5625-0.0117 0.16016 0.0391 0.32032 0.14062 0.42969 0.0781 0.0899 0.19922 0.14063 0.32031 0.14063 0.26954 0 0.5-0.26172 0.51954-0.5586 8e-3 -0.17187-0.043-0.32422-0.14063-0.43359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.973 259.12-5.9023-1.2812-0.12891 0.0898 0.0898 0.12891 5.8984 1.2812h0.0195l0.11328-0.0898"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m79.25 244.86c-0.34765 0-0.61718-0.0781-0.80078-0.23047-0.17968-0.14844-0.26953-0.41015-0.26953-0.77734v-0.10156h0.67969v0.0898c0 0.17969 0.0312 0.30859 0.10156 0.40234 0.0703 0.0781 0.17969 0.12891 0.35156 0.12891 0.11719 0 0.21875-0.043 0.28907-0.10938 0.0781-0.0703 0.10937-0.17187 0.10937-0.3125 0-0.0976-0.0195-0.1875-0.0508-0.25781-0.0391-0.0703-0.10937-0.13281-0.23047-0.17969-0.39844-0.16015-0.64844-0.26953-0.73828-0.32031-0.10156-0.0508-0.17969-0.12109-0.24219-0.1914-0.0586-0.0703-0.11718-0.16016-0.16015-0.26954-0.0391-0.10156-0.0586-0.21875-0.0586-0.37109 0-0.32031 0.0899-0.55859 0.26953-0.73047 0.17969-0.16797 0.44141-0.25 0.76954-0.25 0.33203 0 0.58984 0.082 0.76953 0.23047 0.18359 0.15234 0.27343 0.38281 0.27343 0.69141v0.0781h-0.65234c0-0.32812-0.12109-0.5-0.37109-0.5-0.25782 0-0.38672 0.13281-0.38672 0.39063 0 0.12109 0.0273 0.22265 0.0781 0.28125s0.14063 0.11718 0.26953 0.17968l0.51954 0.23047c0.23046 0.0899 0.39062 0.20703 0.49218 0.34766 0.0977 0.14062 0.14844 0.32031 0.14844 0.54297 0 0.6875-0.39062 1.0273-1.168 1.0273zm-1.2695-0.0586h-1.918v-3.3594h1.8789v0.55078h-1.1992v0.78907h1.1289v0.54687h-1.1289v0.90234h1.25v0.55079zm2.3711-4.0586h-4.2188c-0.77344 0-1.4102 0.62891-1.4102 1.4062v3.3633h7.0273v-3.3633c0-0.76953-0.6289-1.4062-1.4102-1.4062",
    fill: "#050606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel12);
export default __webpack_public_path__ + "static/media/Label12.ecb751e5159ab6e2f582ef986a000910.svg";
export { ForwardRef as ReactComponent };